/* eslint-disabled */
'use strict';

import Cropper from "cropperjs";
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useMemo, createRef } from 'react';
import ReactDOM from 'react-dom';
import Dropzone from 'react-dropzone';
import { DownloadFile } from './AttachFile';
import { Loading } from './Control';
import { HAComponent } from './Generic';
import { ColGroup, Freezing, getOverWidth } from './Utils';
import { VirtualList } from './VirtualList';
import { MobileContext } from './Context';
import { I18n } from './I18n';

class Forming extends HAComponent {
	static version = '0.1.1';
	static propTypes = {
		submittable: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
		submit: PropTypes.func,
	};
	static defaultProps = {
		submittingText: OptionUtils.getLabel('components.Dialogs', 'sending'),
	};
	state = {
		isSubmitting: false,
	};
	inputs = {};

	constructor(props) {
		super(props);
		const { inputs } = this.props;
		if (inputs) this.inputs = inputs;

		this.validate = this.validate.bind(this);
		this.submittable = this.submittable.bind(this);
		this.submit = this.submit.bind(this);
	}

	reset() {
		_.values(this.inputs).map(input => {
			if (input) input.reset();
		});
		return this;
	}

	validate() {
		const { validate } = this.props;
		return _.reduce(this.inputs, (result, input, idx) => {
			if (!input) return result;
			return input.validate() && result;
		}, true) && (!validate || (typeof validate == 'function' && validate(this)));
	}
	submittable() { return true; }
	submit() { }

	getValue(id) {
		const input = this.inputs[id];
		//if (input instanceof J104Picker) input.blur();
		return !input || !input.isEnable() ? undefined : input.getValue();
	}
	getValues() {
		const values = _.mapValues(
			_.pickBy(this.inputs, o => !(o === null || o === undefined || o === Math.NaN || !o.isEnable())),
			input => input.getValue()
		);
		const { getValues } = this.props;
		return _.isFunction(getValues) ? getValues(values) : values;
	}

	setValue(id, value) {
		const input = this.inputs[id];
		if (!input || !input.isEnable()) return this;
		input.setValue(value);
		return this;
	}
	setValues(values) {
		_.keys(values).map(key => this.setValue(key, values[key]));
		return this;
	}

	getInput(id) {
		return this.inputs[id];
	}

	lock() {
		this.lockedInputs = _.filter(this.inputs, input =>
			input &&
				(!input.isView || (_.isFunction(input.isView) && !input.isView())) &&
				input.isEnable() && input.isEditable() ?
				(input.readOnly() || true) : false
		);
		return this;
	}
	unlock() {
		if (this.lockedInputs) this.lockedInputs.forEach(input => input.editable());
		delete this['lockedInputs'];
		return this;
	}
}

class SubmitButton extends HAComponent {
	static version = '0.0.3';
	static propTypes = {
		form: PropTypes.object,
		submittingText: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
		ico: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
		onSubmit: PropTypes.func,
	};
	static defaultProps = {
		submittingText: OptionUtils.getLabel('components.Dialogs', 'sending'),
	};

	constructor(props) {
		super(props);
		const { form } = this.props;

		if (form && form instanceof Forming) this._form = form;
	}

	componentDidMount() {
		super.componentDidMount();
		if (!this._form) {
			const _seekParent = fiber => {
				if (!fiber || !fiber.return) return false;
				const node = fiber.return.stateNode;
				return node instanceof Forming ? node : _seekParent(fiber.return);
			};
			this._form = _seekParent(this._reactInternalFiber);
			if (this._form) this.forceUpdate();
		}
	}

	shake() {
		const btn = this._dom.btn;
		if (btn) btn.addClass('errorShake').removeClass.delay(200, btn, 'errorShake');
	}

	render() {
		if (!this._form) return null;

		const { style,className, children, ico, submittingText, isSubmitting, onSubmit, _btnCss } = this.props;
		const { props: { submittable: s, submit: sb }, submittable, validate, submit } = this._form;
		const isSubmittable = _.isBoolean(s) ? s : _.isFunction(s) ? s(this._form) : submittable();
		const _ico = _.isFunction(ico) ? ico(this) : ico;
		const icoStr = _.isString(_ico) ? ` fa fa-${_ico}` : ' ';
		const btnCss = `btn btn-${_btnCss ? _btnCss : 'primary'}${_ico && !isSubmitting ? icoStr : ''} ${className ? className : ''}`.trim();

		return isSubmitting ? <span className={`${btnCss} disabled`} style={style}>
			<Loading theme={'light'} style={{marginRight: 10}} /> {submittingText}
		</span> : isSubmittable ? <span {...{
			ref: ele => this._dom.btn = ele,
			className: `${btnCss}`,
			style,
			onClick: evt => {
				if (isSubmittable && validate())
					_.isFunction(onSubmit) ? onSubmit() : _.isFunction(sb) ? sb(this._form) : submit();
				else this.shake();
			},
		}}>{children}</span> : <span className={`${btnCss} disabled`} style={style}>{children}</span>;
	}
}


const _calWidth = w => {
	const WM = {
		full: '98%',
		lg: 1024,
		sd: 800,
		md: 720,
		sm: 600,
		xs: 360,
	};
	return _.isString(w) && _.includes(_.keys(WM), w) ? { width: WM[w] } : _calLength(w);
};

const _calLength = (src, type = 'width') => {
	const prop = type === 'width' ? 'width' : 'height';
	const result = {};
	const _transferPercent = (str) => {
		const percent = (str).toInt();
		if (_.isNumber(percent)) {
			const len = window.getSize()[type === 'width' ? 'x' : 'y'] * percent / 100;
			return _.isArray(src) ? (len < src[1] ? src[1] : len > src[2] ? src[2] : len) : len;
		}
		else return str;
	};
	if (_.isArray(src)) {
		if (src.length === 2) {
			result[`min${_.capitalize(prop)}`] = src[0];
			result[`max${_.capitalize(prop)}`] = src[1];
		}
		else if (src.length === 3) {
			result[prop] = _transferPercent(src[0]);
			result[`min${_.capitalize(prop)}`] = src[1];
			result[`max${_.capitalize(prop)}`] = src[2];
		}
		else result[prop] = src;
	}
	else if (_.last(src) === '%') result[prop] = _transferPercent(src);
	else result[prop] = src;
	return result;
};
class Box extends Forming {
	static version = '1.0.3';
	static propTypes = {
		//stick: PropTypes.node,
		stickDirection: PropTypes.oneOf(['inside', 'auto', 'ver', 'hor', 'top', 'bottom', 'left', 'right']),
		stickAlign: PropTypes.number,
		stickOffset: PropTypes.object,
		theme: PropTypes.string,
		style: PropTypes.object,
		modal: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
		level: PropTypes.number,
		closeByESC: PropTypes.bool,
		closeByClickBox: PropTypes.bool,
		closeByClickDocument: PropTypes.bool,
		close: PropTypes.func,
		//inject: PropTypes.oneOfType([PropTypes.element, PropTypes.bool]),
		openFx: PropTypes.string,
		isEventControl: PropTypes.bool,
		eventLevel: PropTypes.number,
		pointer: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['top', 'bottom', 'left', 'right'])]),
		pointerClassName: PropTypes.string,
		pointerStyle: PropTypes.object,
		// 限制y軸不超出視窗邊界
		limitY: PropTypes.bool,
	};
	static defaultProps = {
		stick: document.body,
		stickDirection: 'inside',
		stickAlign: 0,
		stickOffset: null,
		modal: false,
		level: 1,
		closeByESC: true,
		closeByClickBox: false,
		closeByClickDocument: true,
		clickExcludes: null,
		inject: document.body,
		openFx: null,
		eventLevel: 0,
		pointer: false,
		isEventControl: false,
		listenResize: true,
		limitY: false,
	};
	static clickEventQueue = [];
	static keyupEventQueue = [];
	static eventLevels = {};
	static contextType = MobileContext;
	_props = {};

	constructor(props) {
		super(props);
		this._clickEvent = this._clickEvent.bind(this);
		this._keyupEvent = this._keyupEvent.bind(this);
		this._resizeEvent = this._resizeEvent.bind(this);
		const { close, listenResize, isEventControl, eventLevel } = this.props;
		if (!_.isFunction(close)) {
			console.warn(`${this.constructor.name} 需要的 props: "close" 啦，不然無法關閉`);
			// H2.devError({ msg: `${this.constructor.name} 需要的 props: "close" 啦，不然無法關閉` });
			this._props.close = () => { };
		}
		document.addEventListener('click', this._clickEvent);
		document.addEventListener('keyup', this._keyupEvent);
		if (listenResize) window.addEventListener('resize', this._resizeEvent);

		if (isEventControl) {
			this.eventLevel = eventLevel;
			if (Box.eventLevels[eventLevel]) Box.eventLevels[eventLevel]._close();
			Box.eventLevels[eventLevel] = this;
		}

		if (_.isString(this.props.pointer)) this.state.pointerDirection = this.props.pointer;
	}

	componentDidMount() {
		super.componentDidMount();
		this.position();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		//this.position();
	}

	componentWillUnmount() {
		super.componentWillUnmount();
		const { isEventControl, eventLevel } = this.props;
		setTimeout(() => {
			document.removeEventListener('click', this._clickEvent);
			document.removeEventListener('keyup', this._keyupEvent);
			window.removeEventListener('resize', this._resizeEvent);
			if (isEventControl && Box.eventLevels[eventLevel] === this) delete Box.eventLevels[eventLevel];
		}, 0);
	}

	getEventLevel() {
		return this.props.eventLevel;
	}

	getIsOverWidth() {
		let currentWidth = _calWidth(this.props.width)?.width;
		let isOverWidth = getOverWidth(currentWidth);
		return isOverWidth;
	}

	_close(evt) {
		const { close, isEventControl, eventLevel } = this.props;
		if (_.isFunction(close)) close(evt);
		// 			close(() => {
		// 				document.removeEventListener('click', this._clickEvent);
		// 				document.removeEventListener('keyup', this._keyupEvent);
		// 				window.removeEventListener('resize', this._resizeEvent);
		// 				if(isEventControl && Box.eventLevels[eventLevel] === this) delete Box.eventLevels[eventLevel];
		// 			});
	}

	_clickEvent(evt) {
		const { isEventControl, eventLevel, inject } = this.props;
		if (isEventControl) {
			const maxEventLevel = +(_.max(_.keys(Box.eventLevels)) || 0);
			if (eventLevel < maxEventLevel) return;
		}

		const { closeByClickBox, closeByClickDocument, clickExcludes } = this.props;
		const { box, wrapper } = this._dom;
		const excludes = !clickExcludes ? [] : _.isArray(clickExcludes) ? clickExcludes : [clickExcludes];
		const target = evt.target;
		const _isContains = regions =>
			target.getProperty('_belong') || _.some(evt.composedPath(), t => _.some(regions, e => e === t));

		if (closeByClickBox && (!inject && !box || _isContains([wrapper]) && !_isContains(excludes)))
			return this._close(evt);
		if (closeByClickDocument && (!inject && !box || !_isContains([wrapper]) && !_isContains(excludes)))
			return this._close(evt);
	}
	_keyupEvent(evt) {
		const { closeByESC } = this.props;
		const key = evt.key;
		if (closeByESC && key === 'Escape') {
			const { isEventControl, eventLevel } = this.props;
			if (isEventControl) {
				const maxEventLevel = +(_.max(_.keys(Box.eventLevels)) || 0);
				if (eventLevel < maxEventLevel) return;
			}
			this._close(evt);
		}
	}
	_resizeEvent(evt) {
		this.forceUpdate(() => this.position());
	}

	position() {
		const { stick, stickAlign: align, stickOffset: offset, stickDirection: dir, pointer, limitY } = this.props;
		const { wrapper: dom } = this._dom;

		if (stick && dom) {
			const _getDirectionSpace = src => {
				const winSize = window.getSize();
				const coor = src.getCoordinates();
				const docScroll = document.getScroll();
				return {
					top: coor.top - docScroll.y,
					right: docScroll.x + winSize.x - coor.left - coor.width,
					bottom: docScroll.y + winSize.y - coor.top - coor.height,
					left: coor.left - docScroll.x
				};
			};
			const { top, bottom, right, left } = _getDirectionSpace(stick);

			const _transfer = (dir) => {
				if (dir === 'inside') return { position: 'center', edge: 'center' };

				let posX, posY, edgeX, edgeY;
				if (dir === 'auto') dir = top + bottom >= left + right ? 'ver' : 'hor';
				if (dir === 'ver') {
					posX = align === 0 ? 'center' : align > 0 ? 'right' : 'left';
					posY = top > bottom ? 'top' : 'bottom';
					edgeX = align === 0 ? 'center' : align > 0 ? 'right' : 'left';
					edgeY = top > bottom ? 'bottom' : 'top';
				}
				else if (dir === 'hor') {
					posX = left > right ? 'left' : 'right';
					posY = align === 0 ? 'center' : align > 0 ? 'bottom' : 'top';
					edgeX = left > right ? 'right' : 'left';
					edgeY = align === 0 ? 'center' : align > 0 ? 'bottom' : 'top';
				}
				else if (dir === 'top') {
					posX = align === 0 ? 'center' : align > 0 ? 'right' : 'left';
					posY = 'top';
					edgeX = align === 0 ? 'center' : align > 0 ? 'right' : 'left';
					edgeY = 'bottom';
				}
				else if (dir === 'bottom') {
					posX = align === 0 ? 'center' : align > 0 ? 'right' : 'left';
					posY = 'bottom';
					edgeX = align === 0 ? 'center' : align > 0 ? 'right' : 'left';
					edgeY = 'top';
				}
				else if (dir === 'left') {
					posX = 'left';
					posY = align === 0 ? 'center' : align > 0 ? 'bottom' : 'top';
					edgeX = 'right';
					edgeY = align === 0 ? 'center' : align > 0 ? 'bottom' : 'top';
				}
				else if (dir === 'right') {
					posX = 'right';
					posY = align === 0 ? 'center' : align > 0 ? 'bottom' : 'top';
					edgeX = 'left';
					edgeY = align === 0 ? 'center' : align > 0 ? 'bottom' : 'top';
				}
				return {
					position: { x: posX, y: posY },
					edge: { x: edgeX, y: edgeY },
				};
			};
			const pos = _transfer(dir);
			const D = 8;
			const PX = { x: D }, NX = { x: -D }, PY = { y: D }, NY = { y: -D };
			const calOffset =
				dir === 'hor' || (dir === 'auto' && (top + bottom) < (left + right)) ? (left > right ? NX : PX) :
					dir === 'ver' || (dir === 'auto' && (top + bottom) >= (left + right)) ? (top > bottom ? NY : PY) :
						dir === 'top' ? NY :
							dir === 'bottom' ? PY :
								dir === 'left' ? NX :
									dir === 'right' ? PX : null;

			const maximum = {
				x: document.body.getSize().x - dom.getSize().x - 8,
			};

			if (limitY) {
				maximum.y = document.body.getSize().y - dom.getSize().y;
			}

			dom.position({
				relativeTo: stick,
				...pos,
				allowNegative: false,
				maximum,
				offset: {
					x: 0, y: 0,
					...pointer ? calOffset : null,
					...offset,
				},
			});

			if (pointer === true) {
				const d =
					dir === 'hor' || (dir === 'auto' && (top + bottom) < (left + right)) ? (left > right ? 'right' : 'left') :
						dir === 'ver' || (dir === 'auto' && (top + bottom) >= (left + right)) ? (top > bottom ? 'bottom' : 'top') :
							dir === 'top' ? 'bottom' :
								dir === 'bottom' ? 'top' :
									dir === 'left' ? 'right' :
										dir === 'right' ? 'left' : null;
				this.setState({ pointerDirection: d });
				// if(this._dom.pointer)
				// 	this._dom.pointer.position({
				// 		relativeTo: dom,
				// 		... _transfer(d),
				// 		allowNegative: true,
				// 	});
			}
		}
	}

	renderConfirm() { }
	renderBoxBody() {
		return this.renderBody();
	}
	renderBody(d) {
		const { renderBody: body, children } = this.props;
		return body ? (_.isFunction(body) ? body(d) : body) : children;
	}
	renderExtra() { }

	setRef(el) {
		this._dom.wrapper = el;
	}

	render() {
		const { className, theme, width, height, level, modal, style, openFx, inject, wrapperStyle } = {
			... this.props,
			... this._props,
		};
		const isOverWidth = this.getIsOverWidth();

		const _renderPointer = () => {
			const { pointerClassName: css, pointerStyle: s } = this.props;
			const { pointerDirection } = this.state;
			return pointerDirection ? <span {... {
				ref: ele => this._dom.pointer = ele,
				className: `pointer-${pointerDirection}` + (css ? ` ${css}` : ''),
				...s ? { style: s } : null
			}} /> : null;
		};

		const box = <>
			<div {... {
				ref: ele => this._dom.box = ele,
				className: (() => {
					let css = 'H2-Box';
					css += modal ? ` modal${isOverWidth ? ' -overwidth' : ''}` : '';
					css += _.isString(modal) ? ` ${modal}` : '';
					css += theme ? ` ${theme}` : '';
					return css;
				})(), style,
			}}>
				<div {... {
					ref: ele => {
						this.setRef(ele);
					},
					// 由於動畫效果在內部寬度大於容器時會造成計算錯誤，所以先移除
					className: `-wrapper ${openFx ? openFx : ''} ${className ? className : ''}`,
					style: {
						...width ? _calWidth(width) : null,
						...height ? _calLength(height, 'height') : null,
						...level > 1 ? { zIndex: level + 100 } : null,
						...wrapperStyle,
						...isOverWidth ? {
							width: '98vw',
							minWidth: null,
						} : {}
					}
				}}>{this.renderBoxBody()}{_renderPointer()}</div>
				{this.renderExtra()}
			</div>
			{this.renderConfirm()}
		</>;
		return inject ? ReactDOM.createPortal(box, inject) : box;
	}
}

class Tip extends Box {
	static version = '1.0.0';
	static propTypes = {
		...Box.propTypes,
		pointer: PropTypes.bool,
	};
	static defaultProps = {
		...Box.defaultProps,
		//inject: false,
		stickDirection: 'auto',
		pointer: true,
		pointerClassName: 'sm',
		openFx: 'an-zoomInEnlarge',
		close: () => { },
	};

	constructor(props) {
		super(props);
		const { theme } = this.props;
		this._props = {
			modal: false,
			theme: `tip ${theme ? theme : ''}`,
		};
	}

	renderBody() {
		const { children, tipMargin='6px 12px' } = this.props;
		return <div style={{ margin: tipMargin }}>{children}</div>;
	}
}

class TipBinder extends HAComponent {
	static version = '1.0.1';
	static propTypes = {
		tip: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
		event: PropTypes.oneOf(['hover', 'click']),
		tipProps: PropTypes.object,
		direction: PropTypes.oneOf(['auto', 'ver', 'hor', 'top', 'bottom', 'left', 'right']),
		align: PropTypes.number,
		offset: PropTypes.object,
	};
	static defaultProps = {
		element: 'span',
		event: 'hover',
		useOverOutEvent: false,
	};
	state = {
		showTip: false,
	};

	render() {
		const {
			element: Element, useOverOutEvent,
			event, tip, tipProps, direction, align, offset,
			className, style, children, onMouseEnter, onMouseLeave, onClick,disabled = false,
			wrapperStyle,
		} = this.props;
		const { showTip } = this.state;

		return <>
			{showTip && !disabled ? <Tip {...{
				...tipProps,
				...direction ? { stickDirection: direction } : null,
				...align ? { stickAlign: align } : null,
				...offset ? { stickOffset: offset } : null,
				...wrapperStyle ? { wrapperStyle } : null,
				stick: this._dom.root,
				close: () => this.setState({ showTip: false }),
				closeByClickDocument: event === 'click',
			}}>{tip}</Tip> : null}

			<Element {... {
				ref: ele => this._dom.root = ele,
				className, style,
				...event === 'hover' && {
					...useOverOutEvent ? {
						onMouseOver: evt => {
							evt.stopPropagation();
							this.setState({ showTip: true }, _.isFunction(onMouseEnter) ? () => onMouseEnter(evt) : null);
						},
						onMouseOut: evt => {
							evt.stopPropagation();
							this.setState({ showTip: false }, _.isFunction(onMouseLeave) ? () => onMouseLeave(evt) : null);
						},
					} : {
						onMouseEnter: evt => this.setState({ showTip: true }, _.isFunction(onMouseEnter) ? () => onMouseEnter(evt) : null),
						onMouseLeave: evt => this.setState({ showTip: false }, _.isFunction(onMouseLeave) ? () => onMouseLeave(evt) : null),
					},
				},
				...event === 'click' ? {
					onClick: evt => !this.state.showTip &&  !disabled ? this.setState({ showTip: true }, _.isFunction(onClick) &&  !disabled  ? () => onClick(evt) : null) : null,
				} : { onClick : !disabled ? onClick :null },
				disabled
			}} >{children}</Element>
		</>;
	}
}

class Confirm extends Box {
	static version = '0.0.3';
	static propTypes = {
		...Box.propTypes,
		ico: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
		icoWeight: PropTypes.oneOf(['normal', 'bold']),
		yes: PropTypes.func,
		nope: PropTypes.func,
		yesText: PropTypes.string,
		nopeText: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
		yesStyle: PropTypes.string,
		nopeStyle: PropTypes.string,
	};
	static defaultProps = {
		...Box.defaultProps,
		width: [300, 600],
		height: [150, 300],
		closeByClickDocument: false,
		ico: 'question-circle',
		yesText: OptionUtils.getLabel('global.normal', 'yes'),
		nopeText: OptionUtils.getLabel('global.normal', 'no'), // false 時不呈現此按鈕
		yesStyle: 'btn-primary fa fa-check',
		nopeStyle: 'btn-default fa fa-times',
		level: 10,
		openFx: 'an-zoomInEnlarge',
		modal: 'transparent',
	};

	constructor(props) {
		super(props);
		const { theme, className } = this.props;
		this._props = {
			theme: `confirm ${theme ? theme : ''}`,
			className: `an-250ms an-zoomInEnlarge ${className ? className : ''}`,
		};
	}

	renderBoxBody() {
		const { ico, icoWeight, yes, nope, close, yesText, nopeText, yesStyle, nopeStyle } = {
			... this.props,
			... this._props,
		};
		return <>
			<div className={'-body'}>
				{ico ? <i className={`-ico ${icoWeight === 'normal' ? 'fal' : 'fa'} fa-${ico} fa-3x`} /> : null}
				<div className={'-content'}>{this.renderBody()}</div>
			</div>
			<div className={'-footer'}>
				<span {... {
					className: `btn ${yesStyle}`,
					onClick: evt => {
						if (_.isFunction(yes)) yes();
						if (_.isFunction(close)) close();
					},
				}}>{yesText}</span>
				{nopeText !== false && <span {...{
					className: `btn ${nopeStyle}`,
					onClick: evt => {
						if (_.isFunction(nope)) nope();
						if (_.isFunction(close)) close();
					},
				}}>{nopeText}</span>}
			</div>
		</>;
	}
}

class Dialog extends Box {
	static version = '1.1.1';
	static propTypes = {
		...Box.propTypes,
		ico: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
		icoWeight: PropTypes.oneOf(['normal', 'bold']),
		title: PropTypes.oneOfType([PropTypes.element, PropTypes.func, PropTypes.string]),
		isFooter: PropTypes.bool,
		isDraggable: PropTypes.bool,
		isOk: PropTypes.bool,
		isClose: PropTypes.bool,
		onOk: PropTypes.func,
		okText: PropTypes.string,
		isCancel: PropTypes.bool,
		onCancel: PropTypes.func,
		cancelText: PropTypes.string,
	};
	static defaultProps = {
		...Box.defaultProps,
		modal: 'gray',
		closeByESC: false,
		closeByClickDocument: false,
		ico: false,
		icoWeight: 'normal',
		title: '104 HR Max',
		isHeader: true,
		isFooter: true,
		isDraggable: true,
		isOk: true,
		isClose: true,
		okText: OptionUtils.getLabel('global.normal', 'sure'),
		workingText: OptionUtils.getLabel('components.Dialogs', 'processing'),
		isCancel: true,
		cancelText: OptionUtils.getLabel('global.normal', 'cancel'),
		width: 'sd',
		openFx: 'an-zoomInEnlarge',
	};
	state = {
		... this.state,
		working: false,
		loading: false,
		data: null,
	};

	constructor(props) {
		super(props);
		const { theme, className } = this.props;
		this._props = {
			theme: `dialog ${theme ? theme : ''}`,
		};
	}

	static getDerivedStateFromProps(props, state) {
		const { working, loading, isFooter, bodyStyle } = props;
		const { _working, _loading, _isFooter, _bodyStyle } = state;
		let s = {};
		if (working !== _working) {
			s._working = working;
			s.working = working;
		}
		if (loading !== _loading) {
			s._loading = loading;
			s.loading = loading;
		}
		if (isFooter !== _isFooter) {
			s._isFooter = isFooter;
			s.isFooter = isFooter;
		}
		if (_.isEqual(bodyStyle, _bodyStyle)) {
			s._bodyStyle = bodyStyle;
			s.bodyStyle = bodyStyle;
		}
		return s;
	}

	componentDidMount() {
		this._mounted = true;
		const isOverWidth = this.getIsOverWidth();
		// 由於內部寬度大於容器時會造成計算錯誤，所以先移除
		if (!isOverWidth) {
			this.position();
		}
		const { isDraggable } = this.props;
		const { head: h } = this._dom;
		if (isDraggable && h)
			new Drag.Move(this._dom.wrapper, { handle: h, container: document.body });
	}

	renderTitle() {
		return this.props.title;
	}

	renderHeaderExtension() {
		return null;
	}

	renderTopSticky() {
		const { renderTopSticky } = this.props;
		return renderTopSticky ? (_.isFunction(renderTopSticky) ? renderTopSticky() : renderTopSticky) : null;
	}

	renderFooter() {
		const {
			renderFooter: footer, close,
			isOk, onOk, okText, workingText, isCancel, onCancel, cancelText
		} = { ...this.props, ...this._props };
		const { working, isSubmitting } = this.state;
		const btns = <>
			{isOk ? <SubmitButton {...{
				submittingText: workingText,
				isSubmitting: working || isSubmitting,
				onSubmit: onOk,
				form: this
			}}>{okText}</SubmitButton> : null}

			{isCancel ? <span {... {
				className: 'btn btn-default',
				onClick: evt => {
					if (_.isFunction(onCancel)) onCancel();
					close();
				},
			}}>{cancelText}</span> : null}
		</>;
		return footer ? typeof footer == 'function' ? footer(btns) : footer : btns;
	}

	setRef(el) {
		this._dom.wrapper = el;
	}

	renderBoxBody() {
		const { bodyClassName, bodyStyle, ico, bgIco, icoWeight, close, loadApi, isHeader, isClose, isDraggable, icoImg, titleStyle, width } = {
			... this.props,
			... this._props,
		};
		const currentWidth = _calWidth(width)?.width;
		const isOverWidth = this.getIsOverWidth();
		const { loading, working, isFooter, data } = this.state;

		const _renderBody = () => {
			if (!loadApi) {
				return this.renderBody(data);
			}
			if (loading) {
				return <Loading size={'lg'} />;
			}
			return data ? this.renderBody(data) : null;
		};

		return <>
			{isHeader ? <div ref={ele => this._dom.head = ele} className={`-header${isDraggable ? ' draggable' : ''}`} >
				<span className={'-title'} style={titleStyle || {}}>
					{ico ? <i className={`${icoWeight === 'normal' ? 'fal' : 'fa'} fa-fw fa-${ico}`} /> : null}
					{icoImg ? <img src={icoImg} width="50"/> : null}
					{' '}{this.renderTitle()}
				</span>
				{this.renderHeaderExtension()}
				{isClose && <span {... {
					className: `-close fal fa-times${working ? ' disable' : ''}`,
					onClick: working ? null : evt => close(),
				}} />}
			</div> : null}
			{this.renderTopSticky()}
			<div {... {
				ref: ele => this._dom.body = ele,
				className: '-body',
			}}>
				<div className={`-inner-body${bodyClassName ? ' ' + bodyClassName : ''}`} style={{
					...isOverWidth ? {
						width: currentWidth - 50,
						...bodyStyle ? bodyStyle : null,
					} : {
						width: '100%',
						...bodyStyle ? bodyStyle : null,
					},
				}}>
					{_renderBody()}
					{_.isFunction(this.renderExtraBody) ? this.renderExtraBody() : null}
				</div>
			</div>
			{bgIco ? <i className={`-bg fa fa-${bgIco}`} /> : null}
			{isFooter ? <div className={'-footer'} style={{
				overflow: isOverWidth ? 'scroll' : '',
				justifyContent: isOverWidth ? 'inherit' : ''
			}}>{this.renderFooter()}</div> : null}
		</>;
	}
}

class ContextMenu extends Box {
	static version = '0.1.0';
	static propTypes = {
		...Box.propTypes,
	};
	static defaultProps = {
		...Box.defaultProps,
		theme: 'contextMenu',
		stickDirection: 'ver',
		stickAlign: -1,
		pointer: false,
		// pointerAlign: 0,
		// pointerOffset: null,
		//inject: false,
	};

	renderBoxBody() {
		return this.renderBody();
	}
}

class DownloadDialog extends Dialog {
	static version = '0.0.2';
	static propTypes = {
		...Dialog.propTypes,
	};
	static defaultProps = {
		...Dialog.defaultProps,
		ico: 'file-download',
		successMsg: OptionUtils.getLabel('components.Dialogs', 'theDownloadIsComplete'),
		okText: OptionUtils.getLabel('components.Dialogs', 'confirmTheDownload'),
		workingText: OptionUtils.getLabel('components.Dialogs', 'downloading'),
		bodyClassName: 'form-horizontal',
	};

	//Can overwrite
	_renderExtBtns() {
		// TODO: later ...
		return '';
	}

	_submit = () => {
		const { api, successMsg, errMsg, errCode } = this.props;
		if (!this.validate()) {
			let s = this._dom.submitBtn;
			s.addClass('errorShake').removeClass.delay(200, s, 'errorShake');
			return false;
		}

		const container = this._dom.body;
		this._ajax.submit = (this._props.submitAjax || (opts => new _BlobAjax(opts)))({
			url: api,
			method: 'post',
			data: this.getValues(),
			onRequest: () => this.setState({ working: true }, () => this.lock()),
			onComplete: () => this.setState({ working: false }, () => {
				this.unlock();
				Utils.freeVal(this.inputs);
			}),
			onSuccess: (xhr) => {
				Utils.noticeSuccess(container, successMsg);
				if (this.options && this.options.postDown) this.options.postDown(xhr);
				if(_.isFunction(this.props.onSuccess) ) this.props.onSuccess();
				Utils.freeVal(this.inputs);
			},
			errMsg, errCode,
			noticeContainer: container,
		}).send();
	};

	renderFooter() {
		const { okText, workingText, cancelText, close } = this.props;
		const { working: downloading } = this.state;
		return downloading ?
			<span {...{
				className: 'btn btn-primary disabled',
			}}><Loading theme={'light'} /> {workingText}</span> :
			<>
				<span {... {
					ref: ele => this._dom.submitBtn = ele,
					className: 'btn btn-primary',
					onClick: this._submit,
				}}>{okText}</span>
				{this._renderExtBtns()}
				<span {... {
					className: 'btn btn-default',
					onClick: evt => close(),
				}}>{cancelText}</span>
			</>;
	}
}

/**
 * 標準「新增」Dialog：
 * 『只』內建一個新增資料用的 ajax；如果在呈現畫面之前需要事先
 * 透過 ajax 準備其他資料，請在『外界』準備好後在傳入此 dialog
 */
class NewDialog extends Dialog {
	static version = '0.1.0';
	static propTypes = {
		...Dialog.propTypes,
		api: PropTypes.string.isRequired,
		isPin: PropTypes.bool,
		okIco: PropTypes.string,
		okBtnCSS: PropTypes.string,
		workingText: PropTypes.string,
		okConfirm: PropTypes.oneOfType([
			PropTypes.bool, PropTypes.string, PropTypes.element, PropTypes.node, PropTypes.func,
		]),
		okConfirmProps: PropTypes.object,
		onPreSend: PropTypes.func,	// TODO: remove later
		onRequest: PropTypes.func,
		onSuccess: PropTypes.func,
		onError: PropTypes.func,
		successMsg: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
		errMsg: PropTypes.string,
		errCode: PropTypes.object,
		doEdit: PropTypes.func,
		openEdit: PropTypes.bool,
		extBtns: PropTypes.func,
	};
	static defaultProps = {
		...Dialog.defaultProps,
		theme: 'new',
		ico: 'plus',
		//icoWeight: 'bold',
		bgIco: 'file-plus',
		isPin: false,//暫時先不顯示
		okIco: 'plus',
		okBtnCSS: 'btn-success',
		okText: OptionUtils.getLabel('components.Dialogs', 'identifyAdditions'),
		workingText: OptionUtils.getLabel('components.Dialogs', 'newInProgress'),
		okConfirm: false,
		bodyClassName: 'form-horizontal',
		isHandleError: true,
	};
	state = {
		... this.state,
		pinned: false,
		pinHover: false,
		confirm: null,
	};

	componentDidMount() {
		super.componentDidMount();
		if (this._dom.pin && !this._dom.tip) this.forceUpdate();
	}

	renderConfirm() {
		const { okConfirmProps } = this.props;
		const { confirm } = this.state;
		return confirm ? <Confirm {... {
			...okConfirmProps,
			yes: () => this._ajax.submit.send(),
			close: () => this.setState({ confirm: null }),
		}}>{confirm}</Confirm> : null;
	}

	validate() {
		let v = super.validate();
		// TODO: remove below later!!!
		const { onPreSend } = this.props;
		if (onPreSend) v = onPreSend(this.inputs, v) && v;
		return v;
	}

	submit() {
		const {
			okConfirm, close, doEdit,
			successMsg, errMsg, errCode, onRequest, onSuccess, onError, openEdit, openCont,
			isHandleError, ajaxOptions = {}
		} = this.props;
		const { pinned } = this.state;
		const container = this._dom.body;
		this._ajax.submit = new _Ajax({
			url: this.props.api,
			method: 'post',
			data: this.getValues(),
			isHandleError,
			onRequest: () => this.setState({ working: true }, () => {
				this.lock();
				if (_.isFunction(onRequest)) onRequest();
			}),
			onSuccess: (data, xhr) => {
				this.unlock();
				this.setState({ working: false }, () => {
					if (_.isFunction(onSuccess)) onSuccess(data, xhr);

					const msg = _.isString(successMsg) ? successMsg :
						_.isFunction(successMsg) ? successMsg(data, xhr) : null;
					if (pinned) {
						this.reset();
						if (msg) Utils.noticeSuccess(container, msg);
					}
					else {
						close();
						if (openEdit && doEdit) doEdit(data.id);
						if (msg) Utils.noticeSuccess(openCont?.current || openCont || H2._dom.body, msg);
					}
				});
			},
			onError: xhr => {
				this.unlock();
				this.setState({ working: false }, _.isFunction(onError) ? onError(xhr) : void 0);
			},
			errMsg, errCode,
			noticeContainer: container,
			...ajaxOptions,
		});

		if (okConfirm !== false) {
			const confirm = _.isFunction(okConfirm) ? okConfirm(this.getValues()) : okConfirm;
			if (confirm !== false)
				this.setState({ confirm });
			else
				this._ajax.submit.send();
		}
		else this._ajax.submit.send();
	}

	renderFooter() {
		const {
			submittable: s, submit: sb, isOk,
			okIco, okBtnCSS, okText, workingText, isCancel, cancelText, isPin, close, extBtns,
		} = { ...this.props, ...this._props };
		const { working, pinned, pinHover } = this.state;
		const isPortal = !!window.HP;

		const isSubmittable = _.isBoolean(s) ? s : _.isFunction(s) ? s(this) : this.submittable();

		const OKBtn = () => (
			isOk ? <SubmitButton {...{
				submittingText: workingText,
				isSubmitting: working,
				ico: okIco,
				className: okBtnCSS,
				isSubmittable,
				form: this
			}}>{okText}</SubmitButton> : null
		);
		const CancelBtn = () => (
			!isCancel ? null : <span {...{
				className: `btn btn-default${working ? ' disabled' : ''}`,
				onClick: working ? null : close,
			}}>{cancelText}</span>
		);
		return <>
			{
				isPortal ? (
					<>
						<CancelBtn />
						<OKBtn />
					</>
				) : (
					<>
						<OKBtn />
						<CancelBtn />
					</>
				)
			}
			{extBtns && extBtns(close, isSubmittable && (_.isFunction(sb) ? sb(this) : this.submit))}
			{!working && pinHover ? <small className={'color-gray'} style={{ position: 'absolute', right: 50 }}>
				{OptionUtils.getLabel('components.Dialogs', 'theWindowDoesNotCloseAfter')} <i className={'fal fa-arrow-right fa-xs'} />
			</small> : null}

			{isPin ? <>
				<span {... {
					className: `-pin btn btn-white square fa fa-thumbtack${pinned ? ' active' : ''}${working ? ' disabled' : ''}`,
					style: {position: 'absolute', right: 20},
					onClick: evt => working ? null : this.setState({ pinned: !pinned, pinHover: false }),
					...pinned ? null : {
						onMouseEnter: evt => this.setState({ pinHover: true }),
						onMouseLeave: evt => this.setState({ pinHover: false }),
					},
				}} />
			</> : null}
		</>;
	}
}

/**
 * 標準「編輯」Dialog：
 * 繼承 NewDialog, 另外提供取得資料的 ajax (需由傳入id & api)
 * 也可以直接傳入資料本體而不透過 ajax 去後端要資料
 */
class EditDialog extends NewDialog {
	static version = '0.0.7';
	static propTypes = {
		...NewDialog.propTypes,
		//data: PropTypes.object,
		id: PropTypes.number,
		loadApi: PropTypes.string,
		loadMethod: PropTypes.oneOf(['get', 'post']),
		loadErrMsg: PropTypes.string,
		loadErrCode: PropTypes.object,
		onLoadSuccess: PropTypes.func,
		onLoadError: PropTypes.func,
		dataStorer: PropTypes.func,
		appendStateData: PropTypes.bool,
	};
	static defaultProps = {
		...NewDialog.defaultProps,
		theme: 'edit',
		ico: 'pen-alt',
		bgIco: 'file-signature',
		isPin: false,
		okIco: 'pen-alt',
		okBtnCSS: 'btn-primary',
		okText: OptionUtils.getLabel('components.Dialogs', 'identifyModifications'),
		workingText: OptionUtils.getLabel('components.Dialogs', 'underModification'),
		appendStateData: true,
	};

	constructor(props) {
		super(props);
		const { data } = this.props;
		if (data) {
			this.state.data = data;
			this.state.loading = false;
		}
		else this.state.loading = true;
	}

	getValues() {
		const { id, appendStateData } = this.props;
		return {
			id,
			...appendStateData ? this.state.data : null,
			...super.getValues()
		};
	}

	componentDidMount() {
		super.componentDidMount();

		const { data } = this.state;
		if (data) return this.setValues(data);

		const { id, loadApi, loadMethod, loadErrCode, loadErrMsg, onLoadSuccess, onLoadError, dataStorer } = this.props;
		if (loadApi) {
			const container = this._dom.body;
			this._ajax.load = new _Ajax({
				url: id ? `${loadApi}/${id}` : loadApi,
				method: loadMethod || 'get',
				onRequest: () => this.setState({ loading: true, data: null }),
				onComplete: () => this.position.delay(10, this),
				onSuccess: (data, xhr) => this.setState({
					loading: false,
					..._.isFunction(dataStorer) ? dataStorer(data) : { data },
				}, () => {
					if (_.isFunction(onLoadSuccess)) onLoadSuccess(data, xhr);
					this.setValues(data);
				}),
				onError: xhr => this.setState({ loading: false, data: null }, () => {
					if (_.isFunction(onLoadError)) onLoadError();
				}),
				loadErrMsg, loadErrCode,
				noticeContainer: container,
			}).send();
		}
	}
}

class BrowseDialog extends Dialog {
	static version = '0.0.2';
	static propTypes = {
		idx: PropTypes.number.isRequired,
		dataSet: PropTypes.array,	// format: [{id:1, data:{...}}, ...]
		loadApi: PropTypes.string,
		onLoadSuccess: PropTypes.func,
		onLoadError: PropTypes.func,
		logApi: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
		navigator: PropTypes.bool, // 是否顯示上下頁按鈕
		indicator: PropTypes.bool, // 是否顯示 n / m 的筆數提示
		editable: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
		edit: PropTypes.func,
		dataTransfer: PropTypes.func,
	};
	static defaultProps = {
		...Dialog.defaultProps,
		idx: 0,
		theme: 'browse',
		ico: 'file-search',
		bgIco: 'file-alt',
		logApi: false,
		// editable: true, // 改動無效,別再被騙了!
		navigator: true,
		indicator: true,
		cancelText: OptionUtils.getLabel('global.normal', 'close'),
	};
	state = {
		...this.state,
		idx: this.props.idx,
		logMode: false,
	};

	static NA = <small className={'color-lightGray'}>N/A</small>;
	static dateTime(src) {
		const d = Utils.Format.dateTime(src);
		return d ? d : BrowseDialog.NA;
	}
	static date(src) {
		const d = Utils.Format.date(src);
		return d ? d : BrowseDialog.NA;
	}
	static dateRange(src) {
		const na = BrowseDialog.NA;
		if (!_.isArray(src) || src.length < 2) return na;
		if (src[0] && src[1]) return Utils.Format.dateRange(src);
		else if (!src[0] && src[1]) return na + ' ~ ' + Utils.Format.date(src[1]);
		else if (src[0] && !src[1]) return Utils.Format.date(src[0]) + ' ~ ' + na;
		else return na;
	}
	static timezone(src, timezone) {
		const d = Utils.Format.dateTime(src, true, timezone);
		return d ? d : BrowseDialog.NA;
	}
	static listI18n(src, bg) {
		return <div style={{ marginTop: -4, wordBreak: 'break-word'}}>{
			_.keys(Constants.Locales).map(code =>
				<div key={code} className={'H2-I18nItem'}>
					<span className={`-value ${src && src[code] ? '' : 'empty'}`}
						{...bg ? { style: { backgroundColor: bg, maxWidth: '80%' } } : { style: { maxWidth: '80%' } }}>
						{src && src[code] ? src[code] : OptionUtils.getLabel('components.Dialogs', 'notEntered')}</span>
					<small className={'-i18n'}>
						<i className={'fa fa-sm fa-globe-asia'}> {Constants.Locales[code]}</i>
					</small>
				</div>)
		}</div>;
	}
	static textarea(src, line = 2) {
		return <textarea {... {
			key: new Date().getTime() + Math.random(),
			className: 'read',
			disabled: 'disabled',
			rows: line,
			defaultValue: src,
		}} />;
	}
	static file(uuid, fileName, className) {
		const file = <DownloadFile {...{
			url: H2.utils.downloadUrl(uuid),
			fileName
		}} />;
		return uuid ? file : BrowseDialog.NA;
	}
	static label(key, src) {
		const label = OptionUtils.getLabel(key, src);
		return label ? label : BrowseDialog.NA;
	}
	static labels(key, srcs) {
		const labels = OptionUtils.getJoinedLabels(key, srcs, ', ');
		return !labels ? BrowseDialog.NA : labels;
	}
	static userLabel(collection, id) {
		const obj = _.find(collection, { id: id });
		if (!obj) return BrowseDialog.NA;
		const label = obj.name || obj.label || obj.text;
		return (_.isPlainObject(label) ? LocaleUtils.i18n(label) : label) || BrowseDialog.NA;
	}
	static userLabels(collection, ids) {
		if (!ids || ids.length === 0) return BrowseDialog.NA;
		const objs = _.filter(collection, c => _.includes(ids, c.id));
		const labels = _.map(objs, obj => {
			const label = obj.name || obj.label || obj.text;
			return (_.isPlainObject(label) ? LocaleUtils.i18n(label) : label) || undefined;
		});
		if (labels.length === 0) return BrowseDialog.NA;
		return labels.join(', ');
	}
	static binaryLabels(dataSet, value) {
		const labels = Utils.binaryLabels(dataSet, value);
		return labels ? labels : BrowseDialog.NA;
	}
	static category(cid) {
		const label = CategoryUtils.getLabel(cid);
		return label ? label : BrowseDialog.NA;
	}

	constructor(props) {
		super(props);
		this._load = this._load.bind(this);
		this._move = this._move.bind(this);

		const current = this.props.dataSet[this.props.idx];
		if (current && current.data) this.state.data = current.data;
		else this.state.loading = true;
	}

	componentDidMount() {
		super.componentDidMount();
		const { idx } = this.state;
		const current = this.props.dataSet[idx];
		if (!current.data) this._load(current);
	}

	_load(dataSetElement) {
		if (!dataSetElement) return;
		const { id } = dataSetElement;
		const { loadApi } = this.props;
		this._ajax.load = new _Ajax({
			url: `${loadApi}/${id}`,
			method: 'get',
			onRequest: () => this.setState({ loading: true }),
			onComplete: () => this.position.delay(10, this),
			onSuccess: (data, xhr) => {
				const { dataTransfer: dt, onLoadSuccess } = this.props;
				dataSetElement.data = _.isFunction(dt) ? dt(data) : data;
				if (_.isFunction(onLoadSuccess)) onLoadSuccess(data, xhr);
				this.setState({ loading: false, data });
			},
			onError: () => _.isFunction(this.props.close) && this.props.close(),
			errMsg: OptionUtils.getLabel('components.Dialogs', 'thisInformationCannotBeViewed'),
		}).send();
	}

	_move(direction = 1) {
		const { dataSet } = this.props;
		if (!dataSet) return;
		const size = dataSet ? dataSet.length : 0;

		let idx = this.state.idx;
		idx = direction ? (++idx % size) : (idx == 0 ? (size - 1) : (--idx % size));
		if (!dataSet[idx].data) this.setState({ idx: idx }, () => this._load(dataSet[idx]));
		else this.setState({ idx, data: dataSet[idx].data });
	}

	renderHeaderExtension() {
		const { dataSet, navigator, indicator } = this.props;
		const { idx } = this.state;
		return navigator ? <>
			<span className={'-nav'}>
				<i className={'btn btn-sm btn-white square fa fa-chevron-left'} onClick={evt => this._move(0)} />
				{indicator ? <span className={'-indicator'}><strong>{idx + 1}</strong> / {dataSet ? dataSet.length : 0}</span> : null}
				<i className={'btn btn-sm btn-white square fa fa-chevron-right'} onClick={evt => this._move(1)} />
			</span>
		</> : null;
	}

	renderFooter() {
		const { dataSet, logApi, navigator, indicator, editable, edit, close, isCancel, onCancel, cancelText } = this.props;
		const { idx, logMode, editHover, logHover } = this.state;
		const _get0 = d => Array.isArray(d) ? d[0] : d;
		const data = { ..._get0(dataSet[idx].dataFromGrid), ..._get0(dataSet[idx].data) };
		const isEditable = ({
			boolean: () => editable,
			function: () => editable(data),
		}[typeof editable] || (() => true))();
		return <>
			{/*{navigator ? <>*/}
			{/*	<span className={'-nav'}>*/}
			{/*		<i className={'btn btn-sm btn-white square fa fa-chevron-left'} onClick={evt => this._move(0)}  />*/}
			{/*		{indicator ? <span className={'-indicator'}><strong>{idx + 1}</strong> / {dataSet ? dataSet.length : 0}</span> : null}*/}
			{/*		<i className={'btn btn-sm btn-white square fa fa-chevron-right'} onClick={evt => this._move(1)} />*/}
			{/*	</span>*/}
			{/*	<i className={'-split'} />*/}
			{/*</>: null}*/}
			{isEditable && !logMode ? <span {...{
				className: `btn btn-white square fa fa-pen-alt`,
				onClick: evt => {
					if (!_.isFunction(edit)) return;
					// 判斷 data 是否為 多筆
					Array.isArray(data) ? edit(data[0].id, data[0]) : edit(data.id, data);
					close();
				},
				onMouseEnter: evt => this.setState({ editHover: true }),
				onMouseLeave: evt => this.setState({ editHover: false }),
			}} /> : null}
			<span className={'-space'}>
				{editHover ? <small className={'color-gray'}>
					<i className={'fal fa-arrow-left fa-sm'} />
						{OptionUtils.getLabel('components.Dialogs', 'editTheProfile')}
					</small> : null}
			</span>
			{isCancel ? <span {... {
				className: 'btn btn-default',
				onClick: evt => {
					if (_.isFunction(onCancel)) onCancel();
					close();
				},
			}}>{cancelText}</span> : null}
			<span className={'-space text-right'}>
				{logHover ? <small className={'color-gray'}>
					{logMode ?
						OptionUtils.getLabel('global.normal', 'close') : OptionUtils.getLabel('global.normal', 'show')}
					{OptionUtils.getLabel('components.Dialogs', 'modifyTheJourney')}
					<i className={'fal fa-arrow-right fa-sm'} />
				</small> : null}
			</span>
			{/* logapi暫時先不顯示增加style的display:none */}
			{logApi ? <i style={{display:'none'}} {... {
				ref: ele => this._dom.logBtn = ele,
				className: `btn btn-white square fa fa-clock${logMode ? ' active' : ''}`,
				onClick: evt => this.setState({ logMode: !logMode }, () =>
					!logMode ? this._dom.logPanelBody.addClass('open') : null),
				onMouseEnter: evt => this.setState({ logHover: true }),
				onMouseLeave: evt => this.setState({ logHover: false }),
			}} /> : null}
		</>;
	}

	renderExtraBody() {
		const { dataSet, logApi } = this.props;
		const { idx, logMode } = this.state;
		if (!logMode) return;

		const id = dataSet[idx].id;
		return <div className={'-logPanel'}>
			<div ref={ele => this._dom.logPanelBody = ele} className={'-panelBody'}>
				<i {...{
					className: '-close btn btn-sm square btn-danger fa fa-times',
					onClick: evt => this.setState({ logMode: false }),
				}} />
				<_LogData key={id} id={id} api={logApi} />
			</div>
		</div>;
	}
}
class _LogData extends HAComponent {
	state = {
		data: null,
		loading: false,
		error: null,
	};

	componentDidMount() {
		super.componentDidMount();
		const { id, api } = this.props;
		this._ajax = new _Ajax({
			url: `${api}/${id}`,
			method: 'get',
			onRequest: () => this.setState({ loading: true, error: null }),
			onSuccess: (data, xhr) => {
				this.setState({ data: data, loading: false, error: null });
			},
			onError: (xhr) => {
				this.setState({ data: null, loading: false, error: xhr });
				this._dom.root.error(`載入歷程資料錯誤${MSG[xhr.status] ? (': ' + MSG[xhr.status]) : '!'}`);
			},
		}).send();
	}

	render() {
		const { loading, data, error } = this.state;
		if (loading) return <Loading size={'lg'} />;
		if (error) return <div className={'notice notice-error'}>載入歷程資料錯誤</div>;
		if (!data) return null;

		const { dateTime } = Utils.Format;
		return <>
			<table className={'table table-view table-tight table-nowrap text-sm'}>
				<ColGroup cols={[110, '*', 110, '*']} />
				<tbody>
					<tr>
						<th>登錄資料人員</th>
						<td className={'color-blue'}>{data.initUser}</td>
						<th>最後修改人員</th>
						<td className={'color-blue'}>{data.lastModifyUser}</td>
					</tr>
					<tr>
						<th>登錄時間</th><td className={'color-blue'}>{dateTime(data.initTime)}</td>
						<th>最後修改時間</th><td className={'color-blue'}>{dateTime(data.lastModifyTime)}</td>
					</tr>
				</tbody>
			</table>
			<div className={'-dataWrapper'}>
				<table className={'table log fixedHeader'}>
					<ColGroup cols={[30, 140, 80, 80, '*']} />
					<thead><tr><td>#</td><td>時間</td><td>人員</td><td>動作</td><td>異動欄位</td></tr></thead>
				</table>
				<table className={'table log'}>
					<ColGroup cols={[30, 140, 80, 80, '*']} />
					<thead><tr><td>#</td><td>時間</td><td>人員</td><td>動作</td><td>異動欄位</td></tr></thead>
					<tbody>
						{
							data.logs.map((d, i) => <tr key={d.time}>
								<td>{i + 1}</td>
								<td>{dateTime(d.time)}</td>
								<td>{d.actor}</td>
								<td>{OptionUtils.getLabel('sys.log.type', d.action)}</td>
								<td>{d.detail}</td>
							</tr>)
						}
					</tbody>
				</table>
			</div>
		</>;
	}
}

class ArrangeDialog extends React.PureComponent {
	static version = '0.0.3';
	static propTypes = {
		...EditDialog.propTypes,
		lock: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
		lockReason: PropTypes.string,
		readOnly: PropTypes.bool,
		funCode: PropTypes.string,
		api: PropTypes.string, // 可用 funCode 替代
	};
	static defaultProps = {
		...EditDialog.defaultProps,
		width: 'sm',
		theme: 'arrange',
		ico: 'sort-alt',
		bgIco: 'sort-alt',
		isPin: false,
		bodyClassName: 'H2-Arrange1',
		lock: false,
	};

	state = {};
	_dom = {};

	constructor(props) {
		super(props);

		this.submittable = this.submittable.bind(this);
		this.getValues = this.getValues.bind(this);
	}

	submittable() {
		return this._original && !_.isEqual(_.map(this.state.data, d => d.id), this._original);
	}

	setValues(data) {
		this._original = _.map(data, d => d.id);
	}

	getValues() {
		const { data } = this.state;
		if (!data) return null;
		return { ids: data.map(d => d.id) };
	}

	renderItem(item) {
		const { renderItem } = this.props;
		if (typeof renderItem === 'function') return renderItem(item);

		const { name, code, active } = item;
		return <span>
			<strong>{LocaleUtils.adapt(name)}</strong>
			{code && ` (${code})`}{!active && ` :${OptionUtils.getLabel('global.usedStatus', active)}`}
		</span>;
	}

	renderBody() {
		const { lock, lockReason, readOnly } = this.props;
		const { data, active, hover, dragging, working } = this.state;
		const _dragging = (item, evt) => {
			evt.stopPropagation();

			if (working) return;
			if (this._dragger) {
				this._dragger.destroy();
				this._dragger = null;
			}
			this.setState({ dragging: item });
			const ele = evt.target.parentNode;
			const container = this._dom.container.addClass('dragging');
			const coor = ele.getCoordinates(container);
			coor.left += 60;
			const clone = this._dragger = ele.clone().addClass('dragging').inject(container).setStyles(coor);
			ele.addClass('dragBase');
			clone.makeDraggable({
				container: this._dom.container,
				droppables: '.droppable',
				onDrop: (drag, droppable, event) => {
					clone.destroy();
					if (droppable) _moveTo(droppable.getProperty('id') * 1);
					this.setState({ dragging: false });
				},
				onEnter: (ele, droppable) => droppable.addClass('dropping'),
				onLeave: (ele, droppable) => droppable.removeClass('dropping'),
				onCancel: () => {
					clone.destroy();
					this.setState({ dragging: false });
				},
			}).start(new DOMEvent(evt.nativeEvent));
		};
		const activeIdx = _.indexOf(data, active);
		const _moveTo = targetId => {
			if (working || !active) return;
			data.splice(activeIdx, 1);
			if (targetId == 0) data.push(active);
			else data.splice(_.findIndex(data, { id: targetId }), 0, active);
			this.forceUpdate();
		};
		const _moveTop = evt => {
			if (working || !active) return;
			if (activeIdx == 0) return;
			data.splice(activeIdx, 1);
			data.splice(0, 0, active);
			this.forceUpdate();
		};
		const _moveUp = evt => {
			if (working || !active) return;
			if (activeIdx == 0) return;
			data.splice(activeIdx, 1);
			data.splice(activeIdx - 1, 0, active);
			this.forceUpdate();
		};
		const _moveDown = evt => {
			if (working || !active) return;
			if (activeIdx == data.length - 1) return;
			data.splice(activeIdx, 1);
			data.splice(activeIdx + 1, 0, active);
			this.forceUpdate();
		};
		const _moveBottom = evt => {
			if (working || !active) return;
			if (activeIdx == data.length - 1) return;
			data.splice(activeIdx, 1);
			data.push(active);
			this.forceUpdate();
		};
		return <div className={'flex-row align-start'}>
			<div {...{
				ref: ele => this._dom.container = ele,
				className: `-banks -gum${active ? ' hasActive' : ''}${dragging ? ' dragging' : ''}`,
			}}>
				{data.map((d, idx) => {
					const isLock = _.isFunction(lock) ? lock(d) : lock;
					const isDroppable = activeIdx >= 0 && activeIdx != idx && idx != (activeIdx + 1);
					return <React.Fragment key={d.id}>
						{active ? <div id={d.id} className={`-slot${isDroppable ? ' droppable' : ''}`} /> : null}
						<div className={'-bank flex-row'}>
							<span className={'-no'}>{idx + 1}</span>
							<span {...{
								className: `-item flex-row${d == active ? ' active' : ''}${isLock ? ' lock' : ''}${dragging === d ? ' dragBase' : ''}`,
								...readOnly || working ? null : isLock ? {
									onMouseEnter: evt => this.setState({ hover: d }),
									onMouseLeave: evt => this.setState({ hover: null }),
								} : { onClick: evt => this.setState({ active: active == d ? null : d }) },
							}} >
								<span className={'-gum'}>{this.renderItem(d)}</span>
								{!readOnly && <>
									{isLock ? <>
										{hover === d ? <small>{lockReason}<i className={'fal fa-fw fa-arrow-right'} /></small> : null}
										<i className={'fa fa-lock-alt'} />
									</> : ''}
									{!isLock && d == active ? <i className={'-handler fal fa-bars'} onMouseDown={_dragging.bind(this, d)} /> : null}
									{!isLock && d == active ? <i className={'-dir fal fa-arrows-v'} /> : null}
								</>}
							</span>
						</div>
					</React.Fragment>;
				})}
				{active ? <div id={0} className={`-slot${activeIdx < data.length - 1 ? ' droppable' : ''}`} /> : null}
			</div>
			{!readOnly && <span className={'-ctrl btn-group btn-group-white vertical btn-group-lg'}>
				<span {...{
					className: `btn fa fa-arrow-alt-to-top ${working || !active || activeIdx === 0 ? 'disabled' : ''}`,
					...working || !active || activeIdx === 0 ? null : { onClick: _moveTop },
				}} />
				<span {...{
					className: `btn fa fa-arrow-alt-up ${working || !active || activeIdx === 0 ? 'disabled' : ''}`,
					...working || !active || activeIdx === 0 ? null : { onClick: _moveUp },
				}} />
				<span {...{
					className: `btn fa fa-arrow-alt-down ${working || !active || activeIdx === data.length - 1 ? 'disabled' : ''}`,
					...working || !active || activeIdx === data.length - 1 ? null : { onClick: _moveDown },
				}} />
				<span {...{
					className: `btn fa fa-arrow-alt-to-bottom ${working || !active || activeIdx === data.length - 1 ? 'disabled' : ''}`,
					...working || !active || activeIdx === data.length - 1 ? null : { onClick: _moveBottom },
				}} />
			</span>}
		</div>;
	}

	render() {
		const { readOnly, funCode } = this.props;
		const { data } = this.state;
		return <EditDialog {...{
			...funCode && {
				loadApi: `/api/${funCode.toLowerCase()}/arrange/list`,
				api: `/api/${funCode.toLowerCase()}/arrange/save`,
			},
			...this.props,
			onLoadSuccess: data => this.setState({ data }, () => this.setValues(data)),
			...readOnly ? {
				title: '檢視顯示順序',
				isOk: false,
				cancelText: '關閉',
				bodyClassName: 'H2-Arrange1 readOnly',
			} : {
				title: '調整顯示順序',
				okIco: 'save',
				okText: '確定儲存',
				workingText: '儲存中',
				successMsg: '調整順序完成',
				submittable: this.submittable,
				getValues: this.getValues,
			},
		}}>{data && this.renderBody()}</EditDialog>;
	}
}

class StepDialog extends Dialog {
	static version = '0.1.3';
	static propTypes = {
		...Dialog.propTypes,
		initStep: PropTypes.number,
		initStore: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
		stepLabels: PropTypes.array,
		stepComponents: PropTypes.array,
		onFinish: PropTypes.func,
	};
	static defaultProps = {
		...Dialog.defaultProps,
		theme: 'step',
		ico: 'shoe-prints',
		initStep: 0,
	};
	state = {
		... this.state,
		step: this.props.initStep,
		components: new Array(this.props.stepLabels.length),
		instances: new Array(this.props.stepLabels.length),
		store: null,
		footerBtnDisabledActive: this.props.footerBtnDisabledActive || false,
		footerBtnDisabled: false,
	};

	setFooterBtnDisabled = (disabled) => {
		this.setState({ footerBtnDisabled: disabled });
	};

	constructor(props) {
		super(props);
		const { stepLabels: labels, stepComponents, initStore } = this.props;
		this.state.store = _.isPlainObject(initStore) ? _.cloneDeep(initStore) : _.isFunction(initStore) ? initStore(props) : {};
		const components = _.isArray(stepComponents) ? stepComponents : stepComponents ? [stepComponents] : [];
		_.forEach(labels, (label, idx) => {
			const c = components.length > idx ? components[idx] : <StepComponent />;
			this.state.components[idx] = React.cloneElement(c, {
				key: idx,
				parent: this,
				instance: instance => {
					if (!instance) return;
					this.state.instances[idx] = instance;
					this.forceUpdate();
				},
				step: idx,
				stepLength: labels.length,
				store: this.state.store,
			});
		});
	}

	renderTopSticky() {
		const { stepLabels: labels } = this.props;
		const { step } = this.state;
		return <div className={'-steps'}>
			{_.map(labels, (label, idx) => <span {... {
				key: idx,
				className: `-step ${step === idx ? 'active' : step > idx ? 'passed' : ''}`,
				style: { zIndex: labels.length - idx }
			}}><span className={'-wrapper'}>
					<span className={'-no'}>{step > idx ? <i className={'fal fa-check'} /> : (idx + 1)}</span>
					<span className={'-label'}>{label}</span>
				</span></span>)}
		</div>;
	}

	renderFooter() {
		const { stepLabels: labels, close, onFinish } = this.props;
		const { step, instances, store, footerBtnDisabledActive, footerBtnDisabled } = this.state;
		const c = instances[step];
		if (!c) return null;

		const isFirst = step === 0;
		const isLast = (labels.length - 1) === step;
		const isPrev = c.isPrev();
		const isNext = c.isNext();
		const isFinish = c.isFinish();
		return <>
			{
				isFirst ? null : <span {... {
					className: `btn btn-white${isPrev ? '' : ' hidden'} ${footerBtnDisabledActive && footerBtnDisabled ? 'disabled' : ''} fa fa-arrow-alt-left`,
                    ...isPrev ? {
                        onClick: evt => {
							if (footerBtnDisabledActive){
								if (footerBtnDisabled) return;
								this.setState({ footerBtnDisabled: true }, () => {
									c.prev(() => this.setState({ step: step - 1, footerBtnDisabled: false }));
								});
							} else {
								c.prev(() => this.setState({ step: step - 1 }));
							}
                        }
                    } : null,
				}}>{c.renderPrevLabel()} { footerBtnDisabledActive && footerBtnDisabled && !isFinish ? <Loading size={'xs'} /> : null }</span>
			}
			<span className={'-space'} />
			{
				isLast ? <span {... {
					className: `btn btn-primary${isFinish ? '' : ' hidden'} fa fa-check`,
					...isFinish ? {
						onClick: evt => setTimeout(() => {
							c.finish(close);
							if (_.isFunction(onFinish)) onFinish(store);
						}, 0)
					} : null,
				}}>{c.renderFinishLabel()}</span> : <span {... {
					className: `btn btn-white${isNext ? '' : ' hidden'} ${footerBtnDisabledActive && footerBtnDisabled ? 'disabled' : ''} fa fa-arrow-alt-right`,
                    ...isNext ? {
                        onClick: evt => {
							if (footerBtnDisabledActive){
								if (footerBtnDisabled) return;
								this.setState({ footerBtnDisabled: true }, () => {
									setTimeout(() => c.next(() => this.setState({ step: step + 1, footerBtnDisabled: false })), 0);
								});
							} else {
								setTimeout(() => c.next(() => this.setState({ step: step + 1 })), 0);
							}
                        }
                    } : null,
				}}>{c.renderNextLabel()} { footerBtnDisabledActive && footerBtnDisabled ? <Loading size={'xs'} /> : null }</span>
			}
		</>;
	}

	renderBody() {
		const { step, components } = this.state;
		return components[step];
	}
}

class StepComponent extends HAComponent {
	static version = '1.0.1';
	static propTypes = {
		next: PropTypes.func,
		prev: PropTypes.func,
		finish: PropTypes.func,
		height: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.array]),
	};
	static defaultProps = {
		prevText: OptionUtils.getLabel('components.Dialogs', 'previousStep'),
		nextText: OptionUtils.getLabel('components.Dialogs', 'next'),
		finishText: OptionUtils.getLabel('global.normal', 'finish'),
	};

	constructor(props) {
		super(props);
		const { parent } = this.props;
		const _setState = this.setState.bind(this);
		this.setState = (state, cb) => _setState(state, () => parent.forceUpdate(cb));
		const _forceUpdate = this.forceUpdate.bind(this);
		this.forceUpdate = (cb) => _forceUpdate(() => parent.forceUpdate(cb));
	}

	componentDidMount() {
		super.componentDidMount();
		this.props.instance(this);
	}

	close() {
		this.props.parent.props.close();
		return this;
	}

	isPrev() { return true; }
	isNext() { return true; }
	isFinish() { return true; }

	prev(cb) {
		const { prev } = this.props;
		return _.isFunction(prev) ? prev(cb) : cb();
	}

	next(cb) {
		const { next } = this.props;
		return _.isFunction(next) ? next(cb) : cb();
	}

	finish(cb) {
		const { finish } = this.props;
		return _.isFunction(finish) ? finish(cb) : cb();
	}

	renderPrevLabel() {
		return this.props.prevText;
	}

	renderNextLabel() {
		return this.props.nextText;
	}

	renderFinishLabel() {
		return this.props.finishText;
	}

	/**
	 * @return {JSX.Element|string}
	 */
	renderBody() {
		const { step, stepLength } = this.props;
		return `Step ${step + 1}/${stepLength}`;
	}

	render() {
		const { height, style, className } = this.props;

		return height || style || className ? <div {... {
			className,
			style: {
				...height ? _calLength(height, 'height') : null,
				...height ? { margin: '-10px -20px', overflowY: 'auto', overflowX: 'hidden' } : null,
				...style,
			},
		}}>{this.renderBody()}</div> : this.renderBody();
	}
}

// TODO 在 Dialog 把 loadApi, loading 跟 data 調整好之前，先把這個跟 StepDialog 分開...
// 不然兩個應該是可以整併在一起的
class LongTimeStepDialog extends HAComponent {
	static propTypes = {
		loadApi: PropTypes.string.isRequired,
	};
	static defaultProps = {};

	state = {
		...this.state,
		initializing: true,
	};

	constructor(props) {
		super(props);

		const { loadApi, initStore } = this.props;

		if (!loadApi) {
			H2.devError({ msg: `${this.constructor.name} 需要 props: "loadApi" ，不然無法載入長時作業資料` });
		}

		this.state.initStore = _.isPlainObject(initStore) ? _.cloneDeep(initStore) : _.isFunction(initStore) ? initStore(props) : {};
	}

	componentDidMount() {
		const { loadApi, jobId } = this.props;
		if (loadApi && jobId) {
			this._ajax.job = new _Ajax({
				url: `${loadApi}/${jobId}`,
				method: 'get',
				onSuccess: ({ nextStep, store }) => {
					const initStep = nextStep;
					this.setState(state => ({ initializing: false, initStep, initStore: { ...state.initStore, ...store, jobId } }));
				},
				onError: () => this.props.close(),
				errMsg: OptionUtils.getLabel('components.Dialogs', 'unableToLoadLongJobInformation'),
			}).send();
		} else this.setState({ initializing: false });
	};

	render() {
		const { initializing, initStep, initStore } = this.state;
		if (initializing) return null;

		return <StepDialog {...{
			..._.omit(this.props, ['loadApi']),
			ref: ele => this.dlg = ele,
			..._.isNumber(initStep) && { initStep },
			initStore,
		}} />;
	}
}

/**
 * 因為長時作業的關係，請避免重複使用相同的實體。
 * (因為 jobId 卡在 props 裡)
 * (建議 parsed 後都用 close() 結束區段操作)
 */
class ImportDialog extends Dialog {
	static propTypes = {
		...Dialog.propTypes,
		invalidApi: PropTypes.string,
		initFormat: PropTypes.string.isRequired,
		formats: PropTypes.object.isRequired,
		sample: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
		samples: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
		downloadInvalid: PropTypes.bool,
		detachWhenClose: PropTypes.bool,
		jobId: PropTypes.number,
		grid: PropTypes.object,
		onParseSuccess: PropTypes.func,
		onParseError: PropTypes.func,
		onValidateSuccess: PropTypes.func,
		onValidateError: PropTypes.func,
		onCommitSuccess: PropTypes.func,
		onCommitError: PropTypes.func,
		parseSuccessMsg: PropTypes.string,
		parseErrMsg: PropTypes.string,
		parseErrCode: PropTypes.object,
		validateSuccessMsg: PropTypes.string,
		validateErrMsg: PropTypes.string,
		validateErrCode: PropTypes.object,
		commitSuccessMsg: PropTypes.string,
		commitErrMsg: PropTypes.string,
		commitErrCode: PropTypes.object,
		itemHeight: PropTypes.number
	};
	static defaultProps = {
		...Dialog.defaultProps,
		theme: 'import',
		ico: 'plus',
		bgIco: 'file-import',
		width: 'lg',
		height: '95%',
		detachWhenClose: true, // 是否自動在 willUnMount 時刪除暫存檔案
		initFormat: 'default',
		formats: { // dropdown 可處理的檔案格式及相對應的訊息
			'default': {
				dropZoneMsg: OptionUtils.getLabel('components.Dialogs', 'pleaseClickToSelectTheImport'),
				fileRejectMsg: OptionUtils.getLabel('components.Dialogs', 'theFileFormatIsIncorrect'),
				fileSize: 10 * 1024 * 1024,
				fileAccept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
			},
		},
		sample: '', // 不能跟 samples 混用
		samples: null, // 不能跟 sample 混用
		downloadInvalid: true,
		grid: null, // 匯入完成時，要重新整理的 Grid 實體 (使用時要注意實體產生的時間點)
		onParseSuccess: null,
		onParseError: null,
		onValidateSuccess: null,
		onValidateError: null,
		onCommitSuccess: null,
		onCommitError: null,
		parseSuccessMsg: null,
		parseErrMsg: null,
		parseErrCode: null,
		validateSuccessMsg: null,
		validateErrMsg: null,
		validateErrCode: null,
		commitSuccessMsg: null,
		commitErrMsg: null,
		commitErrCode: null,
		itemHeight: 40,
	};
	state = {
		...this.state,
		format: this.props.initFormat,
		file: null, // File object from browser
		fileUUID: '',
		isInitializing: !!this.props.jobId,
		isParsing: false,
		parsed: null, // 解析後的 *物件*
		isValidating: false,
		validated: null, // 驗證後的 *物件*
		isCommitting: false,
		committed: null, // 匯入後的 *物件*
		isCanceling: false,
		isDownloadingSample: false,
		isDownloadingInvalid: false,
	};

	constructor(props) {
		super(props);

		this.reset = this.reset.bind(this);
		this.cancel = this.cancel.bind(this);
		this._upload = this._upload.bind(this);
		this._validate = this._validate.bind(this);
		this._commit = this._commit.bind(this);
		this._downloadInvalid = this._downloadInvalid.bind(this);
		this._renderValidatedRow = this._renderValidatedRow.bind(this);
		this._renderCommittedRow = this._renderCommittedRow.bind(this);
		this.scrollRef = createRef();
	}

	componentDidMount() {
		super.componentDidMount();
		const { jobId } = this.props;
		if (jobId) {
			this._ajax.loading = new _Ajax({
				url: this._getUrl(`longTime/${jobId}`),
				method: 'get',
				onComplete: () => delete this._ajax.loading,
				onSuccess: (data, xhr) => {
					if (this._jobLoad) return this._jobLoad(data, xhr);

					const { status, rows, cols, file, fileUUID } = data;
					if (status === 'validated') {
						file.name = file.originalname;
						const validated = this._handleValidated({ rows, cols });
						this.setState({ ...this.initState(data), isInitializing: false, isValidating: false, validated, fileUUID, file }, () => this.onValidateSuccess(data, xhr));
					} else if (status === 'committed') {
						file.name = file.originalname;
						const committed = this._handleCommitted({ rows, cols });
						this.setState({ ...this.initState(data), isInitializing: false, isCommitting: false, committed, fileUUID, file }, () => this.onCommitSuccess(data, xhr));
					}
				},
			}).send();
		} else this.setState({ isInitializing: false });
	}

	componentWillUnmount() {
		if (this.props.detachWhenClose) this._detach();
		if (this.state.committed && this.props.grid) this.props.grid.reload();
		super.componentWillUnmount();
	}

	initState(data) {
		const { state } = data || {};
		return state || {};
	}

	onParseSuccess(data, xhr) {
		const { onParseSuccess } = this.props;
		if (_.isFunction(onParseSuccess)) onParseSuccess(data, xhr);
	}

	onParseError(xhr) {
		const { onParseError } = this.props;
		if (_.isFunction(onParseError)) onParseError(xhr);
	}

	onValidateSuccess(data, xhr) {
		const { onValidateSuccess } = this.props;
		if (_.isFunction(onValidateSuccess)) onValidateSuccess(data, xhr);
	}

	onValidateError(xhr) {
		const { onValidateError } = this.props;
		if (_.isFunction(onValidateError)) onValidateError(xhr);
	}

	onCommitSuccess(data, xhr) {
		const { onCommitSuccess } = this.props;
		if (_.isFunction(onCommitSuccess)) onCommitSuccess(data, xhr);
	}

	onCommitError(xhr) {
		const { onCommitError } = this.props;
		if (_.isFunction(onCommitError)) onCommitError(xhr);
	}

	reset() {
		this._detach();
		this.setState({
			fileUUID: '',
			file: null,
			working: false,
			isParsing: false,
			parsed: null,
			isValidating: false,
			validated: null,
			isCommitting: false,
			committed: null,
			isDownloadingInvalid: false,
		});
	}

	cancel() {
		const { jobId } = this.props;
		if (jobId && !this._ajax.canceling) {
			this._ajax.canceling = new _Ajax({
				url: `/api/global/import/cancel/${jobId}`,
				method: 'get',
				onRequest: () => this.setState({ working: true, isCanceling: true }),
				onComplete: () => delete this._ajax.canceling,
				onSuccess: (data, xhr) => {
					this._detach();
					this.props.close();
				},
				onError: xhr => this.setState({ working: false, isCanceling: false }),
			}).send();
		} else {
			this._detach();
			this.props.close();
		}
	}

	// 如果想調整 api 的話請先跟 peayton 討論 (例如想加 mainId 或改成 function)
	// 把覆寫這個 method 當作是最終手段...
	_getUrl(suffix) {
		const { formats } = this.props;
		const { format } = this.state;
		if (!formats[format]) {
			Utils.noticeError(this._dom.body, _.template(OptionUtils.getLabel('components.Dialogs', 'nonExistentFormat'))({'temp1': format}));
			return;
		}
		const api = formats[format]?.api || this.props.api;
		return `${api}${suffix ? `/${suffix}` : ''}`;
	}

	_detach() {
		const { fileUUID } = this.state;
		if (fileUUID && !this.detaching) {
			// DO NOT bind to this._ajax!
			this.detaching = new _Ajax({
				url: `api/file/detach/${fileUUID}`,
				method: 'get',
				onComplete: () => this.detaching = null,
			}).send();
		}
	}

	_upload(accepted, rejected) {
		if (this._ajax.uploading) return;

		if (accepted.length === 0) {
			Utils.noticeError(this._dom.body, this.props.formats[this.state.format].fileRejectMsg);
			return;
		}
		const file = accepted[0];
		if (_.some(['\\', '/', ':', '*', '?', '"', '<', '>', '|', '#', '%', '&'], c => { return _.includes(file.name, c); })) {
			Utils.noticeError(this._dom.body, OptionUtils.getLabel('components.Dialogs', 'fileNamesCannotContainSpecialCharacters'));
			return;
		}

		const { parseSuccessMsg, parseErrMsg, parseErrCode: customParseErrCode  } = this.props;

		const parseErrCode = {
			490: '匯入格式錯誤',
			450: '檔案大小超過限制',
			...customParseErrCode, // 合併自定義的錯誤訊息
		};

		const data = this.getValues();
		this._ajax.uploading = new _UploadAjax({
			url: this._getUrl('parse'),
			onRequest: () => this.setState({ working: true, isParsing: true, parsed: null, file: null }),
			onComplete: () => delete this._ajax.uploading,
			onSuccess: (data, xhr) => {
				const { status } = xhr;
				const { fileUUID, ...parsed } = data || {};
				// status:201 空資料集
				this.setState({ working: false, isParsing: false, parsed: status === 200 ? parsed : {}, fileUUID, file }, () => this.onParseSuccess(data, xhr));
			},
			onError: xhr => {
				this.setState({ working: false, isParsing: false, parsed: null }, () => this.onParseError(xhr));
			},
			successMsg: parseSuccessMsg,
			errMsg: parseErrMsg,
			errCode: parseErrCode,
			noticeContainer: this._dom.body,
		});
		_.each(data, (value, key) => this._ajax.uploading.append(key, value));
		this._ajax.uploading.append('import', file).send();
	}

	_handleValidated(data) {
		data.valid = 0;
		data.invalid = 0;
		data.empty = 0;
		data.rows.forEach(row => {
			if (row.$empty) return data.empty++;
			row._invalid = 0;
			_.each(row, d => {if (_.isPlainObject(d) && d.invalid) row._invalid++;});
			data[row._invalid === 0 ? 'valid' : 'invalid'] += 1;
		});
		return data;
	}

	_validate() {
		if (this._ajax.validating) return;

		const { validateSuccessMsg, validateErrMsg, validateErrCode } = this.props;
		const data = this.getValues();
		const { fileUUID } = this.state;
		this._ajax.validating = new _Ajax({
			url: this._getUrl('validate'),
			data: { ...data, fileUUID },
			onRequest: () => {
				this.detaching = 1; // 檔案不能刪除
				this.setState({ working: true, isValidating: true, validated: null });
			},
			onComplete: () => delete this._ajax.validating,
			onSuccess: (data, xhr) => {
				if (xhr.status === 201) {
					this.props.close();
					window.toggleProgressWindow(true);
					if (data?.jobId) window.openProgressingDlg({ jobId: data.jobId });
				} else if (xhr.status === 202) {
					const validated = this._handleValidated(data);
					this.setState({ working: false, isValidating: false, validated, fileUUID: data.fileUUID }, () => this.onValidateSuccess(data, xhr));
				} else {
					const committed = this._handleCommitted(data);
					this.setState({ working: false, isValidating: false, committed, fileUUID: data.fileUUID }, () => this.onCommitSuccess(data, xhr));
				}
			},
			onError: xhr => {
				this.setState({ working: false, isValidating: false, validated: null }, () => this.onValidateError(xhr));
			},
			successMsg: validateSuccessMsg,
			errMsg: validateErrMsg,
			errCode: validateErrCode,
			noticeContainer: this._dom.body,
		}).send();
	}

	_downloadInvalid(evt) {
		const { invalidApi } = this.props;
		const { fileUUID, file:{ buffer } } = this.state;
		if (!fileUUID) return Utils.noticeError(this._dom.body, OptionUtils.getLabel('components.Dialogs', 'errorFreeDataIsAvailableFor'));
		new _BlobAjax({
			// 如果想調整 api 的話請先跟 peayton 討論 (例如想加 mainId 或改成 function)
			url: `${invalidApi || '/api/file/invalid'}/${fileUUID}`,
			method: 'get',
			data: {  buffer },
			onRequest: () => this.setState({ isDownloadingInvalid: true }),
			onSuccess: xhr => {
				// 另存新檔視窗出現前還有一些空檔，不要馬上解開下載按鈕
				setTimeout(() => this.setState({ isDownloadingInvalid: false }), 1000);
			},
			onError: () => this.setState({ isDownloadingInvalid: false }),
		}).send();
	}

	_handleCommitted(data) {
		let success = 0;
		let fail = 0;
		_.each(data.rows, row => row.$fail ? fail++ : success++);
		data.success = success;
		data.fail = fail;
		return data;
	}

	_commit() {
		if (this._ajax.committing) return;

		const { jobId, commitSuccessMsg, commitErrMsg, commitErrCode } = this.props;
		const data = this.getValues();
		const { fileUUID } = this.state;
		this._ajax.committing = new _Ajax({
			url: this._getUrl('commit'),
			data: { ...data, fileUUID, jobId },
			onRequest: () => this.setState({ working: true, isCommitting: true, committed: null }),
			onComplete: () => delete this._ajax.committing,
			onSuccess: (data, xhr) => {
				if (xhr.status === 201) {
					this.props.close();
					window.toggleProgressWindow(true);
					if (data?.jobId) window.openProgressingDlg({ jobId: data.jobId });
				}
				const committed = this._handleCommitted(data);
				this.setState({ working: false, isCommitting: false, committed, fileUUID: data.fileUUID }, () => this.onCommitSuccess(data, xhr));
			},
			onError: xhr => {
				this.setState({ working: false, isCommitting: false, committed: null }, () => this.onCommitError(xhr));
			},
			successMsg: commitSuccessMsg,
			errMsg: commitErrMsg,
			errCode: {
				491: OptionUtils.getLabel('components.Dialogs', 'theAssignmentHasEndedPlease'),
				...commitErrCode,
			},
			noticeContainer: this._dom.body,
		}).send();
	}

	_renderCommittedRow(row, rIdx, props) {
		const { committed: { cols } } = this.state;

		return <tr key={`r${rIdx}`} { ...props }>
			<td>{rIdx + 1}</td>
			<td>{row.$fail
				? <div className="color-red"><i className="fa fa-exclamation-circle" /> {OptionUtils.getLabel('components.Dialogs', 'fail')}</div>
				: <span className="color-green"><i className="fa fa-lg fa-check" /> {OptionUtils.getLabel('components.Dialogs', 'succeed')}</span>}
			</td>
			{_.keys(cols).map((key, cIdx) => <td key={`c${cIdx}`}>{row[key] || ''}</td>)}
		</tr>;
	}

	renderCommitted() {
		const { committed: { cols, rows, success, fail } } = this.state;
		const { itemHeight } = this.props;

		return <div style={{ height: '100%' }}>
			<Freezing
				className="-committed"
				ref={this.scrollRef}
				style={{ maxHeight: 'calc(100% - 150px)' }}
				frozen={{ x: 252, y: 34 }}
			>
				<VirtualList title={OptionUtils.getLabel('components.Dialogs', 'importTheResults')}
							 rows={rows}
							 cols={_.values(cols)}
							 scrollRef={this.scrollRef}
							 itemHeight={itemHeight}
							 className="-committed">
					{this._renderCommittedRow}
				</VirtualList>
			</Freezing>
			<div className="-resultPanel row text-center">
				<div className="col-xs-24">
					<h4>
						<i className="fa fa-check color-green" /> {OptionUtils.getLabel('components.Dialogs', 'numberOfSuccesses')} <strong className="color-green">{success}</strong><br />
						<i className="fa fa-exclamation-circle color-red" /> {OptionUtils.getLabel('components.Dialogs', 'numberOfFailures')} <strong className="color-red">{fail}</strong>
					</h4>
					<div className="btn-group">
						<span className="btn btn-default" onClick={() => this.props.close()}>{OptionUtils.getLabel('components.Dialogs', 'closeTheWindow')}</span>
						{!!fail && <span className="btn btn-danger" onClick={this._downloadInvalid}><i className="fa fa-file-import" /> {OptionUtils.getLabel('components.Dialogs', 'downloadFailedData')}</span>}
					</div>
				</div>
			</div>
		</div>;
	}

	_renderValidatedRow(row, rIdx, props) {
		const { validated: { cols } } = this.state;
		return <tr key={`r${rIdx}`} { ...props }>
			<td>{rIdx + 1}</td>
			{row.$empty
				? <>
					<td>{OptionUtils.getLabel('global.normal', 'noInfo')}</td>
					{_.keys(cols).map((key, cIdx) => <td key={`c${cIdx}`} />)}
				</>
				: <>
					<td>{row._invalid === 0
						? <span className="color-green"><i className="fa fa-lg fa-check" /> {OptionUtils.getLabel('global.normal', 'correct')}</span>
						: <div className="color-red">
							<i className="fa fa-exclamation-circle" />
							{/* 共 {row._invalid} 個欄位錯誤 */}
							<I18n key1='components.Dialogs' key2='totalFieldErrors' options={{'temp1': row._invalid}} />
						</div>}
					</td>
					{_.keys(cols).map((key, cIdx) => {
						const cell = row[key];
						return <td key={`c${cIdx}`}>
							{!_.isPlainObject(cell)
								? cell
								: cell.warning
									? <div className="color-orange">
										<i className="fa fa-exclamation-triangle" /> {cell.warning}
										<div>{cell.value}&nbsp;</div>
									</div>
									: <div className="color-red">
										<i className="fa fa-exclamation-circle" /> {cell.invalid}
										<div>{cell.value}&nbsp;</div>
									</div>}
						</td>;
					})}
				</>}
		</tr>;
	}

	renderValidated() {
		const { downloadInvalid, itemHeight } = this.props;
		const { validated: { cols, rows, valid, invalid, empty }, isCanceling, isDownloadingInvalid } = this.state;

		return <div style={{ height: '100%' }}>
			<Freezing
				className="-validated"
				ref={this.scrollRef}
				style={{ maxHeight: 'calc(100% - 150px)' }}
				frozen={{ x: 252, y: 34 }}
			>
				<VirtualList title={OptionUtils.getLabel('components.Dialogs', 'verifyTheStatus')}
							 rows={rows}
							 cols={cols}
							 scrollRef={this.scrollRef}
							 itemHeight={itemHeight}
							 className="-validated">
					{this._renderValidatedRow}
				</VirtualList>
			</Freezing>
			<div className="-resultPanel row text-center">
				<div className={`col-xs-${downloadInvalid ? 12 : 24}`}>
					<h4>
						<i className="fa fa-check color-green" /> {OptionUtils.getLabel('components.Dialogs', 'correctData')} <strong className="color-green">{valid}</strong><br />
						<i className="fa fa-check color-green" style={{ visibility: 'hidden' }} />
						<I18n key1='components.Dialogs' key2='noData' options={{'temp1': empty}} />
					</h4>
					<div className="btn-group">
						{!!valid && <span {...{
							className: `btn btn-primary${isCanceling ? ' disabled' : ''}`,
							...!isCanceling && { onClick: this._commit },
						}}><i className="fa fa-file-import" /> {`${
							!!invalid ?
							OptionUtils.getLabel('components.Dialogs', 'partialImport') :
							OptionUtils.getLabel('components.Dialogs', 'importAll')
						}`}</span>}
						<span {...{
							className: `btn btn-default${isCanceling ? ' disabled' : ''}`,
							...!isCanceling && { onClick: this.cancel },
						}}>{isCanceling ? <Loading /> : <i className="fal fa-times" />}
							{OptionUtils.getLabel('components.Dialogs', 'cancelTheImport')}
						</span>
					</div>
				</div>
				{!downloadInvalid
					? null
					: <div className="col-xs-12">
						<h4>
							<i className="fa fa-exclamation-circle color-red" />
							<I18n key1='components.Dialogs' key2='abnormalData' options={{
								'temp1': <strong className="color-red">{invalid}</strong>
							}} />
						</h4>
						<span {...{
							className: 'btn btn-danger',
							...!isDownloadingInvalid && { onClick: this._downloadInvalid },
						}}>
							{isDownloadingInvalid ? <Loading /> : <i className="fal fa-arrow-to-bottom" />}
							{OptionUtils.getLabel('components.Dialogs', 'downloadErrorData')}
						</span>
					</div>}
			</div>
		</div>;
	}

	renderParsed() {
		const { parsed } = this.state;
		if (!parsed) return null;
		const { headers, excelData } = parsed;
		if (!excelData) return (
			<div className="empty-validateResult">
				{OptionUtils.getLabel('components.Dialogs', 'ifThereIsNoDataIn')}
			</div>
		);

		const numOfCol = _.size(headers);
		return <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
			<Freezing frozen={{ x: 52, y: 34 }}>
				<table className="table table-bordered table-validateResult -parsed">
					<thead>
					<tr>
						<th>#</th>
						{_.values(headers).map((header, cIdx) => <th key={`c${cIdx}`}>{header}</th>)}
					</tr>
					</thead>
					<tbody>{excelData.map((row, rIdx) => {
						return <tr key={`r${rIdx}`}>
							<td>{rIdx + 1}</td>
							{row.map((cell, cIdx) => <td key={`c${cIdx}`}>{cell}</td>)}
							{_.times(numOfCol - _.size(row), eIdx => <td key={`e${eIdx}`} />)}
						</tr>;
					})}
					</tbody>
				</table>
			</Freezing>
			<p>
				<I18n key1='components.Dialogs' key2='afterPreviewingTheFirst' options={{'temp1': <br />,'temp2': <span className="fa fal fa-info-circle" />}} />
			</p>
		</div>;
	}

	renderFileIndicator() {
		const { file, validated, committed, isValidating, isCommitting } = this.state;
		if (!file) return this.props.renderFileIndicator?.(this);
		const fileName = file.name.length >= 40 ? `${file.name.substring(0, 40)}…` : file.name;
		return <div className="pull-left -file fal fa-file-spreadsheet">
			<span className="-name">{fileName}</span>
			<small className="-size">({`${(file.size * 1 / 1024).toInt().format()} KB`})</small>
			{!(validated || committed || isValidating || isCommitting) && <span className="btn btn-xs btn-danger fa fa-times" onClick={this.reset} />}
		</div>;
	}

	renderSampleDownloader() {
		const { format, isDownloadingSample } = this.state;
		const { sample, samples } = this.props;

		// let sampleOnSuccess; // 應該是用不到的？(不然 onRequest, onComplete, onError 之類的也都要準備)
		let _sample = samples?.[format] || sample;
		if (_.isFunction(_sample)) _sample = _sample();
		// if (_.isFunction(_sample.onSuccess)) {
		// 	sampleOnSuccess = _sample.onSuccess;
		// 	delete _sample.onSuccess;
		// }
		if (!_sample) return null;

		const btnLabel = _sample.label || OptionUtils.getLabel('components.Dialogs', 'downloadTheImportSample');

		const _Element = _.isString(_sample) ? 'a' : 'div';
		const eleProps = {
			className: 'btn btn-white pull-right',
			..._Element === 'a' && { href: _sample }, // ONLY for public file
			..._Element === 'div' && !isDownloadingSample && {
				onClick: _sample.onClick || (() => {
					new _BlobAjax({
						method: 'get',
						onRequest: () => this.setState({ isDownloadingSample: true }),
						onSuccess: xhr => {
							// if (_.isFunction(sampleOnSuccess)) sampleOnSuccess(blob, xhr);
							// 另存新檔視窗出現前還有一些空檔，不要馬上解開下載按鈕
							setTimeout(() => this.setState({ isDownloadingSample: false }), 1000);
						},
						onError: () => this.setState({ isDownloadingSample: false }),
						..._.pick(_sample, ['method', 'url', 'data', 'fileName']),
					}).send();
				}),
			},
		};

		return <_Element {...eleProps}>
			{isDownloadingSample ? <Loading /> : <i className="fa fa-arrow-to-bottom" />} {btnLabel}
		</_Element>;
	}

	renderDropzone() {
		const { formats } = this.props;
		const { format, isDownloadingSample } = this.state;
		if (!formats[format]) return OptionUtils.getLabel('components.Dialogs', 'nonExistentFormat2');
		const { fileSize, fileAccept, dropZoneMsg } = formats[format];

		return <>
			{isDownloadingSample && <div className="H2-Box modal transparent" style={{ position: 'absolute' }} />}
			<Dropzone accept={fileAccept} maxSize={fileSize} multiple={false} onDrop={this._upload}>
				{({ getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject }) => {
					return <div className="dropzone" {...getRootProps()}>
						<input {...getInputProps()} />
						<div>{dropZoneMsg}</div>
						<div style={{ textAlign: 'center' }}><i className="fal fa-8x fa-plus" /></div>
					</div>;
				}}
			</Dropzone>
		</>;
	}

	renderTitle() {
		const { title } = this.props;
		const { parsed, validated, committed } = this.state;
		if (committed) return _.template(OptionUtils.getLabel('components.Dialogs', 'ImportResult'))({'temp1': title});
		if (validated) return _.template(OptionUtils.getLabel('components.Dialogs', 'ValidationResult'))({'temp1': title});
		if (parsed) return _.template(OptionUtils.getLabel('components.Dialogs', 'ImportFilePreview'))({'temp1': title});
		return title;
	}

	renderTopSticky() {
		const rendered = super.renderTopSticky();
		if (rendered) return rendered;

		const { isInitializing, isValidating, validated, isCommitting, committed } = this.state;
		if (isInitializing) return null;

		return <div className="-topSticky">
			{committed && <h2>{OptionUtils.getLabel('components.Dialogs', 'theImportIsComplete')}</h2>}
			{this.renderFileIndicator()}
			{!(isValidating || validated || isCommitting || committed) &&
				(<div {...user.locale == 'en_US' && !this.props.noSelLabel &&
					{ className: 'col-xs-24', style: { marginTop: 5 } }}>
					{this.renderSampleDownloader()}
				</div>)}
		</div>;
	}

	renderBody() {
		const { isInitializing, isParsing, parsed, isValidating, validated, isCommitting, committed } = this.state;
		if (isInitializing || isParsing || isValidating || isCommitting) return <Loading size="3x" style={{ height: '100%' }} />;
		if (committed) return this.renderCommitted();
		if (validated) return this.renderValidated();
		if (parsed) return this.renderParsed();
		return this.renderDropzone();
	}

	renderFooter() {
		const { parsed, validated, committed, isInitializing, isValidating, isCommitting } = this.state;
		if (!parsed || validated || committed || isValidating || isCommitting || isInitializing) return null;
		return parsed.excelData && <button {...{
			className: 'btn btn-primary',
			onClick: this._validate,
		}}>
			{OptionUtils.getLabel('components.Dialogs', 'startCheckingTheMaterials')}
		</button> || <button {...{
			className: 'btn btn-default',
			onClick: this.reset,
		}}>
			{OptionUtils.getLabel('components.Dialogs', 'reUploadTheArchive')}
		</button>;
	}
}

/**
 * 圖片裁切工具畫面
 */
class PictureCroppingDialog extends Dialog {
	static defaultProps = {
		...Dialog.defaultProps,
		title: OptionUtils.getLabel('components.Dialogs', 'cropThePicture'),
		width: 800,
		height: 600,
		ico: 'crop',
	};

	componentDidMount() {
		super.componentDidMount();
		const { file, ratio } = this.props;
		this.cropper = new Cropper(this._dom.cropper, { dragMode: 'move' });
		if (ratio) this.cropper.setAspectRatio(ratio);
		const URL = self.URL || self.webkitURL;
		this.cropper.replace(URL.createObjectURL(file));
	}

	renderFooter() {
		const { close, onOk, okText, cancelText, imageSize, previewImageSize } = this.props;
		const { width = 1440, height = 500, quality = 0.9 } = _.isPlainObject(imageSize) ? imageSize : {};
		const { previewWidth = 288, previewHeight = 100, previewQuality = 0.5 } = _.isPlainObject(previewImageSize) ? imageSize : {};
		return <>
		  <span {...{
			  className: 'btn btn-primary',
			  onClick: () => {
				  const dataURL = this.cropper.getCroppedCanvas({ width, height }).toDataURL("image/webp", quality);
				  const previewDataURL = this.cropper.getCroppedCanvas({ width: previewWidth, height: previewHeight }).toDataURL("image/webp", previewQuality);
				  const imageCode = dataURL.replace(/data:image(?:\/\w+)?;base64,/, '');
				  const previewImageCode = previewDataURL.replace(/data:image(?:\/\w+)?;base64,/, '');
				  onOk(imageCode, previewImageCode);
			  },
		  }}>{okText}</span>
			<span {...{
				className: 'btn btn-default',
				onClick: close,
			}}>{cancelText}</span>
		</>;
	}

	renderBody() {
		return <img ref={ele => this._dom.cropper = ele} style={{ width: '100', height: '100' }} />;
	}
}

/**
 * 上傳圖片編輯器
 */
class UploadPictureEditor extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			cropFile: null,
			confirmDel: false,
			readOnly: props.readOnly,
		};
	}

	setReadOnly(readOnly) { this.setState({ readOnly: readOnly === true }); }
	reset() { this.setState({ imageCode: null, previewImageCode: null, readOnly: 0 }); }
	validate() { return true; }
	isView() {}
	isEnable() { return true; }
	enable() {}
	disable() {}
	isEditable() {}
	editable() {}
	readOnly() {}
	getValue() {
		const { imageCode, previewImageCode } = this.state;
		return imageCode || previewImageCode
			? { imageCode, previewImageCode }
			: null;
	}

	setValue({ imageCode, previewImageCode }) {
		this.setState({ imageCode, previewImageCode });
	}

	dropAttr = {
		ref: ele => this.image = ele,
		accept: 'image/pjp,image/jpg,image/pjpeg,image/jpeg,image/jfif,image/png',
		maxSize: 3 * 1024 * 1024,
		multiple: false,
		onDrop: (accepted, rejected) => {
			if (accepted.length === 0) {
				this.root.error(OptionUtils.getLabel('components.Dialogs', 'theUploadedImageIsInThe'), {
					additionClass: 'sm', stick: {
						position: 'topLeft', edge: 'topLeft', offset: { x: 10 },
					},
				});
				return;
			}
			const fileName = accepted[0].name;
			if (/[\\/:*?"<>|#%&]/.test(fileName)) {
				this.root.error(OptionUtils.getLabel('components.Dialogs', 'fileNamesCannotContainSpecialCharacters'));
				return;
			}
			this.setState({ cropFile: accepted[0] });
		},
	};

	render() {
		const { previewImageCode, readOnly, cropFile, uploading, confirmDel } = this.state;
		const { working, ratio, imageSize, previewImageSize, previewStyle, onDelete } = this.props;

		if (readOnly)
			return <div className="imgContainer" style={{margin: '0 5'}}>
				{previewImageCode && <img src={`data:image/jpeg;base64,${previewImageCode}`} style={previewStyle || {height: 90, width: '100%'}}/>}
			</div>;

		if (uploading)
			return <div className="imgContainer" style={{margin: '0 5'}}><span className="loading loading-lg" /></div>;

		if (previewImageCode)
			return <>
				{!!confirmDel &&
					<Confirm {...{
						close: () => this.setState({ confirmDel: false }),
						yes: () => {
							this.setState({ imageCode: null, previewImageCode: null, cropFile: null });
							if (_.isFunction(onDelete)) onDelete();
						},
					}}>{OptionUtils.getLabel('components.Dialogs', 'areYouSureYouWantTo')}</Confirm>
				}
				<div className="imgContainer" style={{margin: '0 5'}}>
					<img src={`data:image/jpeg;base64,${previewImageCode}`} style={previewStyle || {height: 90, width: '100%'}} />
				</div>
				<div {...{
					className: `btn btn-danger fa fa-trash-alt${!working ? ' disable' : ''}`,
					style: { margin: 5 },
					onClick: working ? null :() => this.setState({ confirmDel: true }),
				}}>{OptionUtils.getLabel('components.Dialogs', 'removeTheImage')}</div>
			</>;

		return <div ref={ele => this.root = ele}>
			<Dropzone {...this.dropAttr}>
				{({ getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject }) => {
					const objStyle = {
						backgroundImage: 'unset', outline: 'none', transition: 'border .24s ease-in-out',
					};
					if (isDragReject) objStyle.border = '2px dashed #ff1744';
					else if (isDragAccept) objStyle.border = '2px dashed #00e676';
					else if (isDragActive) objStyle.border = '2px dashed #2196f3 !important';
					return <div {...{
						...getRootProps({ style: useMemo(() => objStyle, [isDragActive, isDragReject]) }),
						className: 'dropzone form-control',
					}} ><input {...getInputProps()} />
						{OptionUtils.getLabel('components.Dialogs', 'DragAndDropAn')}
					</div>;
				}}
			</Dropzone>
			{!!cropFile &&
				<PictureCroppingDialog {...{
					file: cropFile,
					ratio, imageSize, previewImageSize,
					onOk: (imageCode, previewImageCode) => this.setState({ imageCode, previewImageCode, cropFile: null }),
					close: () => this.setState({ cropFile: null }),
				}} />
			}
		</div>;
	}
}

class LongTimeDownloadDialog extends Dialog {
	static version = '0.0.2';
	static propTypes = {
		...Dialog.propTypes,
	};
	static defaultProps = {
		...Dialog.defaultProps,
		ico: 'file-download',
		successMsg: OptionUtils.getLabel('components.Dialogs', 'theDownloadIsComplete'),
		okText: OptionUtils.getLabel('components.Dialogs', 'confirmTheDownload'),
		workingText: OptionUtils.getLabel('components.Dialogs', 'downloading'),
		bodyClassName: 'form-horizontal',
	};

	constructor(props) {
		super(props);
	}

	//Can overwrite
	_renderExtBtns() {
		// TODO: later ...
		return '';
	}

	componentDidMount() {
		const { jobId } = this.props;
		if (jobId) {
			this._ajax.job = new _Ajax({
				url: `/api/ux20010/exportLongTime/${jobId}`,
				method: 'get',
				onRequest: () => this.setState({ fileLoading: true }),
				onSuccess: (data) => {
					const { jobName, extraData, cDatetime } = data;
					this.setState({ fileLoading: false, jobName, extraData, cDatetime });
				},
				onError: () => this.props.close(),
				errMsg: OptionUtils.getLabel('components.Dialogs', 'unableToLoadLongJobInformation'),
			}).send();
		} else this.setState({ fileLoading: false });
	};

	renderTitle() {
		const { title } = this.props, { jobName, extraData } = this.state;
		return typeof title == 'function' ? title(jobName, extraData) : title;
	}

	_submit = () => {
		const { api, successMsg, errMsg, errCode, onSubmit } = this.props;
		if (!this.validate()) {
			let s = this._dom.submitBtn;
			s.addClass('errorShake').removeClass.delay(200, s, 'errorShake');
			return false;
		}
		const container = this._dom.body;
		this._ajax.submit = new _DownloadAjax({
			url: api,
			data: this.getValues(),
			onRequest: () => this.setState({ working: true }, () => this.lock()),
			onComplete: () => this.setState({ working: false }, () => this.unlock()),
			onSuccess: (data, xhr) => {
				if (xhr.status === 201) {
					(this.props.close2 || this.props.close)();
					window.toggleProgressWindow(true);
					if (data?.jobId) window.openProgressingDlg({ jobId: data.jobId });
					if (onSubmit) onSubmit(data, xhr);
				} else {
				Utils.noticeSuccess(container, successMsg);
				}
				if(_.isFunction(this.props.onSuccess) ) this.props.onSuccess();
			},
			errMsg, errCode,
			noticeContainer: this._dom.body,
		}).send();
	};

	renderCriteriaBody() {
		return this.props.children;
	}

	renderDownloadFileBody() {
		const { jobName = '', cDatetime, extraData: { fileUUID, file } = {}, fileLoading } = this.state;
		return ( fileLoading
			? <Loading />
			: <>
				<div className="form-group">
					<label className="col-xs-6 control-label">{jobName}</label>
					<div className="col-xs-16">
						{ fileUUID
							? <DownloadFile url={H2.utils.downloadUrl(fileUUID)} fileName={file?.originalname} />
							: OptionUtils.getLabel('components.Dialogs', 'downloadErrorData') }
					</div>
				</div>
				<div className="form-group">
					<label className="col-xs-6 control-label">建立時間</label>
					<div className="col-xs-6 form-control-static">{cDatetime}</div>
				</div>
			</>);
	}

	renderBody() {
		const { jobId } = this.props;
		return jobId ? this.renderDownloadFileBody() : this.renderCriteriaBody();
	}

	submittable() { return !this.state.working; }

	renderFooter() {
		const { okText, workingText, cancelText, close, jobId } = this.props;
		return !this.submittable() ?
			<span {...{
				className: 'btn btn-primary disabled',
			}}><Loading theme={'light'} /> {workingText}</span> :
			<>
				{ !jobId ?
						<span {... {
						ref: ele => this._dom.submitBtn = ele,
						className: 'btn btn-primary fa fa-arrow-to-bottom',
						onClick: this._submit,
						}}>{okText}</span> : null
				}
				{this._renderExtBtns()}
				<span {... {
					className: 'btn btn-default',
					onClick: evt => close(),
				}}>{jobId ? OptionUtils.getLabel('global.normal', 'close') : cancelText}</span>
			</>;
	}
}

export {
	Forming, SubmitButton,
	Box, Tip, TipBinder, Confirm, ContextMenu,
	Dialog, DownloadDialog, NewDialog, EditDialog, BrowseDialog, ArrangeDialog, ImportDialog,
	StepDialog, StepComponent, LongTimeStepDialog, PictureCroppingDialog, UploadPictureEditor,
	LongTimeDownloadDialog,
};
